unit View.Itens_Entrada.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewItens_EntradaEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcompra_id: TLabel;
    edcompra_id: TDBEdit;
    lbitem: TLabel;
    editem: TDBEdit;
    lbproduto_id: TLabel;
    edproduto_id: TDBEdit;
    lbgrade_produto_id: TLabel;
    edgrade_produto_id: TDBEdit;
    lbproduto_nome: TLabel;
    edproduto_nome: TDBEdit;
    lbmovimenta_estoque: TLabel;
    edmovimenta_estoque: TDBEdit;
    lbestoque_inicial: TLabel;
    edestoque_inicial: TDBEdit;
    lbestoque_final: TLabel;
    edestoque_final: TDBEdit;
    lbcfop_cfop: TLabel;
    edcfop_cfop: TDBEdit;
    lbunidade_id: TLabel;
    edunidade_id: TDBEdit;
    lbquantidade: TLabel;
    edquantidade: TDBEdit;
    lbvalor_unitario: TLabel;
    edvalor_unitario: TDBEdit;
    lbdesconto: TLabel;
    eddesconto: TDBEdit;
    lbvalor_desconto: TLabel;
    edvalor_desconto: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbvalor_base_icms: TLabel;
    edvalor_base_icms: TDBEdit;
    lbicms: TLabel;
    edicms: TDBEdit;
    lbvalor_icms: TLabel;
    edvalor_icms: TDBEdit;
    lbicms_dif: TLabel;
    edicms_dif: TDBEdit;
    lbvalor_icms_dif: TLabel;
    edvalor_icms_dif: TDBEdit;
    lbvalor_base_st: TLabel;
    edvalor_base_st: TDBEdit;
    lbst: TLabel;
    edst: TDBEdit;
    lbvalor_st: TLabel;
    edvalor_st: TDBEdit;
    lbicms_red: TLabel;
    edicms_red: TDBEdit;
    lbvalor_icms_red: TLabel;
    edvalor_icms_red: TDBEdit;
    lbvalor_base_ipi: TLabel;
    edvalor_base_ipi: TDBEdit;
    lbipi: TLabel;
    edipi: TDBEdit;
    lbvalor_ipi: TLabel;
    edvalor_ipi: TDBEdit;
    lbvalor_custo_unitario: TLabel;
    edvalor_custo_unitario: TDBEdit;
    lblote_fabricacao: TLabel;
    edlote_fabricacao: TDBEdit;
    lbdata_fabricacao: TLabel;
    eddata_fabricacao: TDBEdit;
    lbvalidade: TLabel;
    edvalidade: TDBEdit;
    lbdias_validade: TLabel;
    eddias_validade: TDBEdit;
    lbvalor_frete: TLabel;
    edvalor_frete: TDBEdit;
    lbvalor_despensa_acessoria: TLabel;
    edvalor_despensa_acessoria: TDBEdit;
    lbvalor_seguro: TLabel;
    edvalor_seguro: TDBEdit;
    lbvalor_outras: TLabel;
    edvalor_outras: TDBEdit;
    lbcst_id: TLabel;
    edcst_id: TDBEdit;
    lbcst_ipi_id: TLabel;
    edcst_ipi_id: TDBEdit;
    lbcst_pis_id: TLabel;
    edcst_pis_id: TDBEdit;
    lbcst_cofins_id: TLabel;
    edcst_cofins_id: TDBEdit;
    lbcsosn_id: TLabel;
    edcsosn_id: TDBEdit;
    lborigem_csosn_id: TLabel;
    edorigem_csosn_id: TDBEdit;
    lbquantidade_selo_ipi: TLabel;
    edquantidade_selo_ipi: TDBEdit;
    lbvalor_base_issqn: TLabel;
    edvalor_base_issqn: TDBEdit;
    lbissqn: TLabel;
    edissqn: TDBEdit;
    lbcodigo_issqn: TLabel;
    edcodigo_issqn: TDBEdit;
    lbvalor_issqn: TLabel;
    edvalor_issqn: TDBEdit;
    lbvalor_base_pis: TLabel;
    edvalor_base_pis: TDBEdit;
    lbpis: TLabel;
    edpis: TDBEdit;
    lbvalor_pis: TLabel;
    edvalor_pis: TDBEdit;
    lbvalor_base_cofins: TLabel;
    edvalor_base_cofins: TDBEdit;
    lbcofins: TLabel;
    edcofins: TDBEdit;
    lbvalor_cofins: TLabel;
    edvalor_cofins: TDBEdit;
    lbcodigo_bc_piscofins_id: TLabel;
    edcodigo_bc_piscofins_id: TDBEdit;
    lbcodigo_credito_piscofins_id: TLabel;
    edcodigo_credito_piscofins_id: TDBEdit;
    lbvalor_base_st_retida: TLabel;
    edvalor_base_st_retida: TDBEdit;
    lbst_retida: TLabel;
    edst_retida: TDBEdit;
    lbvalor_st_retida: TLabel;
    edvalor_st_retida: TDBEdit;
    lbvalor_pis_retido: TLabel;
    edvalor_pis_retido: TDBEdit;
    lbvalor_cofins_retido: TLabel;
    edvalor_cofins_retido: TDBEdit;
    lbvalor_desconto_nota: TLabel;
    edvalor_desconto_nota: TDBEdit;
    lbvalor_total_liquido: TLabel;
    edvalor_total_liquido: TDBEdit;
    lbvalor_total_impostos: TLabel;
    edvalor_total_impostos: TDBEdit;
    lbvalor_frete_por_fora: TLabel;
    edvalor_frete_por_fora: TDBEdit;
    lbvalor_outras_despesas: TLabel;
    edvalor_outras_despesas: TDBEdit;
    lbvalor_preco_custo: TLabel;
    edvalor_preco_custo: TDBEdit;
    lbvalor_preco_venda: TLabel;
    edvalor_preco_venda: TDBEdit;
    lbvalor_icms_desonerado: TLabel;
    edvalor_icms_desonerado: TDBEdit;
    lbdesoneracao_icms_id: TLabel;
    eddesoneracao_icms_id: TDBEdit;
    lbvalor_icms_proprio_st: TLabel;
    edvalor_icms_proprio_st: TDBEdit;
    lbvalor_icms_original: TLabel;
    edvalor_icms_original: TDBEdit;
    lbplano_contas_contabil_id: TLabel;
    edplano_contas_contabil_id: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientItens_EntradaGet: TXDataWebClient;
    XDataClientItens_EntradaDelete: TXDataWebClient;
    Itens_EntradaDataset: TXDataWebDataSet;
    Itens_EntradaDatasetid: TIntegerField;
    Itens_EntradaDatasetaliado_id: TIntegerField;
    Itens_EntradaDatasetdata_base_id: TIntegerField;
    Itens_EntradaDatasetcompra_id: TIntegerField;
    Itens_EntradaDatasetitem: TIntegerField;
    Itens_EntradaDatasetproduto_id: TIntegerField;
    Itens_EntradaDatasetgrade_produto_id: TIntegerField;
    Itens_EntradaDatasetproduto_nome: TStringField;
    Itens_EntradaDatasetmovimenta_estoque: TBooleanField;
    Itens_EntradaDatasetestoque_inicial: TFloatField;
    Itens_EntradaDatasetestoque_final: TFloatField;
    Itens_EntradaDatasetcfop_cfop: TStringField;
    Itens_EntradaDatasetunidade_id: TIntegerField;
    Itens_EntradaDatasetquantidade: TFloatField;
    Itens_EntradaDatasetvalor_unitario: TFloatField;
    Itens_EntradaDatasetdesconto: TFloatField;
    Itens_EntradaDatasetvalor_desconto: TFloatField;
    Itens_EntradaDatasetvalor_total: TFloatField;
    Itens_EntradaDatasetvalor_base_icms: TFloatField;
    Itens_EntradaDataseticms: TFloatField;
    Itens_EntradaDatasetvalor_icms: TFloatField;
    Itens_EntradaDataseticms_dif: TFloatField;
    Itens_EntradaDatasetvalor_icms_dif: TFloatField;
    Itens_EntradaDatasetvalor_base_st: TFloatField;
    Itens_EntradaDatasetst: TFloatField;
    Itens_EntradaDatasetvalor_st: TFloatField;
    Itens_EntradaDataseticms_red: TFloatField;
    Itens_EntradaDatasetvalor_icms_red: TFloatField;
    Itens_EntradaDatasetvalor_base_ipi: TFloatField;
    Itens_EntradaDatasetipi: TFloatField;
    Itens_EntradaDatasetvalor_ipi: TFloatField;
    Itens_EntradaDatasetvalor_custo_unitario: TFloatField;
    Itens_EntradaDatasetlote_fabricacao: TStringField;
    Itens_EntradaDatasetdata_fabricacao: TDateTimeField;
    Itens_EntradaDatasetvalidade: TDateTimeField;
    Itens_EntradaDatasetdias_validade: TIntegerField;
    Itens_EntradaDatasetvalor_frete: TFloatField;
    Itens_EntradaDatasetvalor_despensa_acessoria: TFloatField;
    Itens_EntradaDatasetvalor_seguro: TFloatField;
    Itens_EntradaDatasetvalor_outras: TFloatField;
    Itens_EntradaDatasetcst_id: TStringField;
    Itens_EntradaDatasetcst_ipi_id: TStringField;
    Itens_EntradaDatasetcst_pis_id: TStringField;
    Itens_EntradaDatasetcst_cofins_id: TStringField;
    Itens_EntradaDatasetcsosn_id: TStringField;
    Itens_EntradaDatasetorigem_csosn_id: TIntegerField;
    Itens_EntradaDatasetquantidade_selo_ipi: TIntegerField;
    Itens_EntradaDatasetvalor_base_issqn: TFloatField;
    Itens_EntradaDatasetissqn: TFloatField;
    Itens_EntradaDatasetcodigo_issqn: TStringField;
    Itens_EntradaDatasetvalor_issqn: TFloatField;
    Itens_EntradaDatasetvalor_base_pis: TFloatField;
    Itens_EntradaDatasetpis: TFloatField;
    Itens_EntradaDatasetvalor_pis: TFloatField;
    Itens_EntradaDatasetvalor_base_cofins: TFloatField;
    Itens_EntradaDatasetcofins: TFloatField;
    Itens_EntradaDatasetvalor_cofins: TFloatField;
    Itens_EntradaDatasetcodigo_bc_piscofins_id: TIntegerField;
    Itens_EntradaDatasetcodigo_credito_piscofins_id: TIntegerField;
    Itens_EntradaDatasetvalor_base_st_retida: TFloatField;
    Itens_EntradaDatasetst_retida: TFloatField;
    Itens_EntradaDatasetvalor_st_retida: TFloatField;
    Itens_EntradaDatasetvalor_pis_retido: TFloatField;
    Itens_EntradaDatasetvalor_cofins_retido: TFloatField;
    Itens_EntradaDatasetvalor_desconto_nota: TFloatField;
    Itens_EntradaDatasetvalor_total_liquido: TFloatField;
    Itens_EntradaDatasetvalor_total_impostos: TFloatField;
    Itens_EntradaDatasetvalor_frete_por_fora: TFloatField;
    Itens_EntradaDatasetvalor_outras_despesas: TFloatField;
    Itens_EntradaDatasetvalor_preco_custo: TFloatField;
    Itens_EntradaDatasetvalor_preco_venda: TFloatField;
    Itens_EntradaDatasetvalor_icms_desonerado: TFloatField;
    Itens_EntradaDatasetdesoneracao_icms_id: TIntegerField;
    Itens_EntradaDatasetvalor_icms_proprio_st: TFloatField;
    Itens_EntradaDatasetvalor_icms_original: TFloatField;
    Itens_EntradaDatasetplano_contas_contabil_id: TIntegerField;
    Itens_EntradaDatasetcodigo_interno: TIntegerField;
    Itens_EntradaDatasetexcluido: TBooleanField;
    Itens_EntradaDatasetinclusao: TDateTimeField;
    Itens_EntradaDatasetalteracao: TDateTimeField;
    Itens_EntradaDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientItens_EntradaGetLoad(Response: TXDataClientResponse);
    procedure XDataClientItens_EntradaDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientItens_EntradaDeleteError(Error: TXDataClientError);
    procedure Itens_EntradaDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewItens_EntradaEdit: TFViewItens_EntradaEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewItens_EntradaEdit }

procedure TFViewItens_EntradaEdit.btSaveClick(Sender: TObject);
begin
  if Itens_EntradaDataset.State in dsEditModes then
  begin
        Itens_EntradaDataset.Post;
    Itens_EntradaDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewItens_EntradaEdit.btDeleteClick(Sender: TObject);
begin
  if Itens_EntradaDataset.State in dsEditModes then
    Itens_EntradaDataset.Post;
  XDataClientItens_EntradaDelete.Delete(Itens_EntradaDataset.EntitySetName,
    TJSObject(Itens_EntradaDataset.CurrentData));
end;


class function TFViewItens_EntradaEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewItens_EntradaEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewItens_EntradaEdit.InsertEntity;
begin
  Itens_EntradaDataset.Close;
  Itens_EntradaDataset.SetJsonData('{}');
  Itens_EntradaDataset.Open;
  Itens_EntradaDataset.Insert;
end;

class function TFViewItens_EntradaEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewItens_EntradaEdit(AForm).FInserting := AInserting;
    TFViewItens_EntradaEdit(AForm).FId := AId;
    TFViewItens_EntradaEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewItens_EntradaEdit(AForm).InsertEntity
    else
      TFViewItens_EntradaEdit(AForm).LoadEntity;
    TFViewItens_EntradaEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewItens_EntradaEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewItens_EntradaEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Itens_EntradaDataset.Connection.Model.DefaultSchema.FindEntityType(
      Itens_EntradaDataset.EntitySetName
    )
  );
  XDataClientItens_EntradaGet.Get(Itens_EntradaDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewItens_EntradaEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewItens_EntradaEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewItens_EntradaEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewItens_EntradaEdit.XDataClientItens_EntradaGetLoad(Response: TXDataClientResponse);
begin
  Itens_EntradaDataset.Close;
  Itens_EntradaDataset.SetJsonData(Response.Result);
  Itens_EntradaDataset.Open;
  
  Itens_EntradaDataset.Edit;  
end;

procedure TFViewItens_EntradaEdit.XDataClientItens_EntradaDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewItens_EntradaEdit.XDataClientItens_EntradaDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewItens_EntradaEdit.Itens_EntradaDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewItens_EntradaEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewItens_EntradaEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.itens_entrada.form.message');
  lbMessage := TLabel.Create('view.itens_entrada.form.message.label');
  btCloseMessage := TButton.Create('view.itens_entrada.form.message.button');
  btCancel := TButton.Create('view.itens_entrada.form.btBack');
  btSave := TButton.Create('view.itens_entrada.form.btSave');
  btDelete := TButton.Create('view.itens_entrada.form.btDelete');
  lbid := TLabel.Create('view.itens_entrada.form.lbid');
  edid := TDBEdit.Create('view.itens_entrada.form.edid');
  lbaliado_id := TLabel.Create('view.itens_entrada.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.itens_entrada.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.itens_entrada.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.itens_entrada.form.eddata_base_id');
  lbcompra_id := TLabel.Create('view.itens_entrada.form.lbcompra_id');
  edcompra_id := TDBEdit.Create('view.itens_entrada.form.edcompra_id');
  lbitem := TLabel.Create('view.itens_entrada.form.lbitem');
  editem := TDBEdit.Create('view.itens_entrada.form.editem');
  lbproduto_id := TLabel.Create('view.itens_entrada.form.lbproduto_id');
  edproduto_id := TDBEdit.Create('view.itens_entrada.form.edproduto_id');
  lbgrade_produto_id := TLabel.Create('view.itens_entrada.form.lbgrade_produto_id');
  edgrade_produto_id := TDBEdit.Create('view.itens_entrada.form.edgrade_produto_id');
  lbproduto_nome := TLabel.Create('view.itens_entrada.form.lbproduto_nome');
  edproduto_nome := TDBEdit.Create('view.itens_entrada.form.edproduto_nome');
  lbmovimenta_estoque := TLabel.Create('view.itens_entrada.form.lbmovimenta_estoque');
  edmovimenta_estoque := TDBEdit.Create('view.itens_entrada.form.edmovimenta_estoque');
  lbestoque_inicial := TLabel.Create('view.itens_entrada.form.lbestoque_inicial');
  edestoque_inicial := TDBEdit.Create('view.itens_entrada.form.edestoque_inicial');
  lbestoque_final := TLabel.Create('view.itens_entrada.form.lbestoque_final');
  edestoque_final := TDBEdit.Create('view.itens_entrada.form.edestoque_final');
  lbcfop_cfop := TLabel.Create('view.itens_entrada.form.lbcfop_cfop');
  edcfop_cfop := TDBEdit.Create('view.itens_entrada.form.edcfop_cfop');
  lbunidade_id := TLabel.Create('view.itens_entrada.form.lbunidade_id');
  edunidade_id := TDBEdit.Create('view.itens_entrada.form.edunidade_id');
  lbquantidade := TLabel.Create('view.itens_entrada.form.lbquantidade');
  edquantidade := TDBEdit.Create('view.itens_entrada.form.edquantidade');
  lbvalor_unitario := TLabel.Create('view.itens_entrada.form.lbvalor_unitario');
  edvalor_unitario := TDBEdit.Create('view.itens_entrada.form.edvalor_unitario');
  lbdesconto := TLabel.Create('view.itens_entrada.form.lbdesconto');
  eddesconto := TDBEdit.Create('view.itens_entrada.form.eddesconto');
  lbvalor_desconto := TLabel.Create('view.itens_entrada.form.lbvalor_desconto');
  edvalor_desconto := TDBEdit.Create('view.itens_entrada.form.edvalor_desconto');
  lbvalor_total := TLabel.Create('view.itens_entrada.form.lbvalor_total');
  edvalor_total := TDBEdit.Create('view.itens_entrada.form.edvalor_total');
  lbvalor_base_icms := TLabel.Create('view.itens_entrada.form.lbvalor_base_icms');
  edvalor_base_icms := TDBEdit.Create('view.itens_entrada.form.edvalor_base_icms');
  lbicms := TLabel.Create('view.itens_entrada.form.lbicms');
  edicms := TDBEdit.Create('view.itens_entrada.form.edicms');
  lbvalor_icms := TLabel.Create('view.itens_entrada.form.lbvalor_icms');
  edvalor_icms := TDBEdit.Create('view.itens_entrada.form.edvalor_icms');
  lbicms_dif := TLabel.Create('view.itens_entrada.form.lbicms_dif');
  edicms_dif := TDBEdit.Create('view.itens_entrada.form.edicms_dif');
  lbvalor_icms_dif := TLabel.Create('view.itens_entrada.form.lbvalor_icms_dif');
  edvalor_icms_dif := TDBEdit.Create('view.itens_entrada.form.edvalor_icms_dif');
  lbvalor_base_st := TLabel.Create('view.itens_entrada.form.lbvalor_base_st');
  edvalor_base_st := TDBEdit.Create('view.itens_entrada.form.edvalor_base_st');
  lbst := TLabel.Create('view.itens_entrada.form.lbst');
  edst := TDBEdit.Create('view.itens_entrada.form.edst');
  lbvalor_st := TLabel.Create('view.itens_entrada.form.lbvalor_st');
  edvalor_st := TDBEdit.Create('view.itens_entrada.form.edvalor_st');
  lbicms_red := TLabel.Create('view.itens_entrada.form.lbicms_red');
  edicms_red := TDBEdit.Create('view.itens_entrada.form.edicms_red');
  lbvalor_icms_red := TLabel.Create('view.itens_entrada.form.lbvalor_icms_red');
  edvalor_icms_red := TDBEdit.Create('view.itens_entrada.form.edvalor_icms_red');
  lbvalor_base_ipi := TLabel.Create('view.itens_entrada.form.lbvalor_base_ipi');
  edvalor_base_ipi := TDBEdit.Create('view.itens_entrada.form.edvalor_base_ipi');
  lbipi := TLabel.Create('view.itens_entrada.form.lbipi');
  edipi := TDBEdit.Create('view.itens_entrada.form.edipi');
  lbvalor_ipi := TLabel.Create('view.itens_entrada.form.lbvalor_ipi');
  edvalor_ipi := TDBEdit.Create('view.itens_entrada.form.edvalor_ipi');
  lbvalor_custo_unitario := TLabel.Create('view.itens_entrada.form.lbvalor_custo_unitario');
  edvalor_custo_unitario := TDBEdit.Create('view.itens_entrada.form.edvalor_custo_unitario');
  lblote_fabricacao := TLabel.Create('view.itens_entrada.form.lblote_fabricacao');
  edlote_fabricacao := TDBEdit.Create('view.itens_entrada.form.edlote_fabricacao');
  lbdata_fabricacao := TLabel.Create('view.itens_entrada.form.lbdata_fabricacao');
  eddata_fabricacao := TDBEdit.Create('view.itens_entrada.form.eddata_fabricacao');
  lbvalidade := TLabel.Create('view.itens_entrada.form.lbvalidade');
  edvalidade := TDBEdit.Create('view.itens_entrada.form.edvalidade');
  lbdias_validade := TLabel.Create('view.itens_entrada.form.lbdias_validade');
  eddias_validade := TDBEdit.Create('view.itens_entrada.form.eddias_validade');
  lbvalor_frete := TLabel.Create('view.itens_entrada.form.lbvalor_frete');
  edvalor_frete := TDBEdit.Create('view.itens_entrada.form.edvalor_frete');
  lbvalor_despensa_acessoria := TLabel.Create('view.itens_entrada.form.lbvalor_despensa_acessoria');
  edvalor_despensa_acessoria := TDBEdit.Create('view.itens_entrada.form.edvalor_despensa_acessoria');
  lbvalor_seguro := TLabel.Create('view.itens_entrada.form.lbvalor_seguro');
  edvalor_seguro := TDBEdit.Create('view.itens_entrada.form.edvalor_seguro');
  lbvalor_outras := TLabel.Create('view.itens_entrada.form.lbvalor_outras');
  edvalor_outras := TDBEdit.Create('view.itens_entrada.form.edvalor_outras');
  lbcst_id := TLabel.Create('view.itens_entrada.form.lbcst_id');
  edcst_id := TDBEdit.Create('view.itens_entrada.form.edcst_id');
  lbcst_ipi_id := TLabel.Create('view.itens_entrada.form.lbcst_ipi_id');
  edcst_ipi_id := TDBEdit.Create('view.itens_entrada.form.edcst_ipi_id');
  lbcst_pis_id := TLabel.Create('view.itens_entrada.form.lbcst_pis_id');
  edcst_pis_id := TDBEdit.Create('view.itens_entrada.form.edcst_pis_id');
  lbcst_cofins_id := TLabel.Create('view.itens_entrada.form.lbcst_cofins_id');
  edcst_cofins_id := TDBEdit.Create('view.itens_entrada.form.edcst_cofins_id');
  lbcsosn_id := TLabel.Create('view.itens_entrada.form.lbcsosn_id');
  edcsosn_id := TDBEdit.Create('view.itens_entrada.form.edcsosn_id');
  lborigem_csosn_id := TLabel.Create('view.itens_entrada.form.lborigem_csosn_id');
  edorigem_csosn_id := TDBEdit.Create('view.itens_entrada.form.edorigem_csosn_id');
  lbquantidade_selo_ipi := TLabel.Create('view.itens_entrada.form.lbquantidade_selo_ipi');
  edquantidade_selo_ipi := TDBEdit.Create('view.itens_entrada.form.edquantidade_selo_ipi');
  lbvalor_base_issqn := TLabel.Create('view.itens_entrada.form.lbvalor_base_issqn');
  edvalor_base_issqn := TDBEdit.Create('view.itens_entrada.form.edvalor_base_issqn');
  lbissqn := TLabel.Create('view.itens_entrada.form.lbissqn');
  edissqn := TDBEdit.Create('view.itens_entrada.form.edissqn');
  lbcodigo_issqn := TLabel.Create('view.itens_entrada.form.lbcodigo_issqn');
  edcodigo_issqn := TDBEdit.Create('view.itens_entrada.form.edcodigo_issqn');
  lbvalor_issqn := TLabel.Create('view.itens_entrada.form.lbvalor_issqn');
  edvalor_issqn := TDBEdit.Create('view.itens_entrada.form.edvalor_issqn');
  lbvalor_base_pis := TLabel.Create('view.itens_entrada.form.lbvalor_base_pis');
  edvalor_base_pis := TDBEdit.Create('view.itens_entrada.form.edvalor_base_pis');
  lbpis := TLabel.Create('view.itens_entrada.form.lbpis');
  edpis := TDBEdit.Create('view.itens_entrada.form.edpis');
  lbvalor_pis := TLabel.Create('view.itens_entrada.form.lbvalor_pis');
  edvalor_pis := TDBEdit.Create('view.itens_entrada.form.edvalor_pis');
  lbvalor_base_cofins := TLabel.Create('view.itens_entrada.form.lbvalor_base_cofins');
  edvalor_base_cofins := TDBEdit.Create('view.itens_entrada.form.edvalor_base_cofins');
  lbcofins := TLabel.Create('view.itens_entrada.form.lbcofins');
  edcofins := TDBEdit.Create('view.itens_entrada.form.edcofins');
  lbvalor_cofins := TLabel.Create('view.itens_entrada.form.lbvalor_cofins');
  edvalor_cofins := TDBEdit.Create('view.itens_entrada.form.edvalor_cofins');
  lbcodigo_bc_piscofins_id := TLabel.Create('view.itens_entrada.form.lbcodigo_bc_piscofins_id');
  edcodigo_bc_piscofins_id := TDBEdit.Create('view.itens_entrada.form.edcodigo_bc_piscofins_id');
  lbcodigo_credito_piscofins_id := TLabel.Create('view.itens_entrada.form.lbcodigo_credito_piscofins_id');
  edcodigo_credito_piscofins_id := TDBEdit.Create('view.itens_entrada.form.edcodigo_credito_piscofins_id');
  lbvalor_base_st_retida := TLabel.Create('view.itens_entrada.form.lbvalor_base_st_retida');
  edvalor_base_st_retida := TDBEdit.Create('view.itens_entrada.form.edvalor_base_st_retida');
  lbst_retida := TLabel.Create('view.itens_entrada.form.lbst_retida');
  edst_retida := TDBEdit.Create('view.itens_entrada.form.edst_retida');
  lbvalor_st_retida := TLabel.Create('view.itens_entrada.form.lbvalor_st_retida');
  edvalor_st_retida := TDBEdit.Create('view.itens_entrada.form.edvalor_st_retida');
  lbvalor_pis_retido := TLabel.Create('view.itens_entrada.form.lbvalor_pis_retido');
  edvalor_pis_retido := TDBEdit.Create('view.itens_entrada.form.edvalor_pis_retido');
  lbvalor_cofins_retido := TLabel.Create('view.itens_entrada.form.lbvalor_cofins_retido');
  edvalor_cofins_retido := TDBEdit.Create('view.itens_entrada.form.edvalor_cofins_retido');
  lbvalor_desconto_nota := TLabel.Create('view.itens_entrada.form.lbvalor_desconto_nota');
  edvalor_desconto_nota := TDBEdit.Create('view.itens_entrada.form.edvalor_desconto_nota');
  lbvalor_total_liquido := TLabel.Create('view.itens_entrada.form.lbvalor_total_liquido');
  edvalor_total_liquido := TDBEdit.Create('view.itens_entrada.form.edvalor_total_liquido');
  lbvalor_total_impostos := TLabel.Create('view.itens_entrada.form.lbvalor_total_impostos');
  edvalor_total_impostos := TDBEdit.Create('view.itens_entrada.form.edvalor_total_impostos');
  lbvalor_frete_por_fora := TLabel.Create('view.itens_entrada.form.lbvalor_frete_por_fora');
  edvalor_frete_por_fora := TDBEdit.Create('view.itens_entrada.form.edvalor_frete_por_fora');
  lbvalor_outras_despesas := TLabel.Create('view.itens_entrada.form.lbvalor_outras_despesas');
  edvalor_outras_despesas := TDBEdit.Create('view.itens_entrada.form.edvalor_outras_despesas');
  lbvalor_preco_custo := TLabel.Create('view.itens_entrada.form.lbvalor_preco_custo');
  edvalor_preco_custo := TDBEdit.Create('view.itens_entrada.form.edvalor_preco_custo');
  lbvalor_preco_venda := TLabel.Create('view.itens_entrada.form.lbvalor_preco_venda');
  edvalor_preco_venda := TDBEdit.Create('view.itens_entrada.form.edvalor_preco_venda');
  lbvalor_icms_desonerado := TLabel.Create('view.itens_entrada.form.lbvalor_icms_desonerado');
  edvalor_icms_desonerado := TDBEdit.Create('view.itens_entrada.form.edvalor_icms_desonerado');
  lbdesoneracao_icms_id := TLabel.Create('view.itens_entrada.form.lbdesoneracao_icms_id');
  eddesoneracao_icms_id := TDBEdit.Create('view.itens_entrada.form.eddesoneracao_icms_id');
  lbvalor_icms_proprio_st := TLabel.Create('view.itens_entrada.form.lbvalor_icms_proprio_st');
  edvalor_icms_proprio_st := TDBEdit.Create('view.itens_entrada.form.edvalor_icms_proprio_st');
  lbvalor_icms_original := TLabel.Create('view.itens_entrada.form.lbvalor_icms_original');
  edvalor_icms_original := TDBEdit.Create('view.itens_entrada.form.edvalor_icms_original');
  lbplano_contas_contabil_id := TLabel.Create('view.itens_entrada.form.lbplano_contas_contabil_id');
  edplano_contas_contabil_id := TDBEdit.Create('view.itens_entrada.form.edplano_contas_contabil_id');
  lbcodigo_interno := TLabel.Create('view.itens_entrada.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.itens_entrada.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.itens_entrada.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.itens_entrada.form.edexcluido');
  lbinclusao := TLabel.Create('view.itens_entrada.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.itens_entrada.form.edinclusao');
  lbalteracao := TLabel.Create('view.itens_entrada.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.itens_entrada.form.edalteracao');
  lbexclusao := TLabel.Create('view.itens_entrada.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.itens_entrada.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Itens_EntradaDataset := TXDataWebDataSet.Create(Self);
  Itens_EntradaDatasetid := TIntegerField.Create(Self);
  Itens_EntradaDatasetaliado_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetdata_base_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetcompra_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetitem := TIntegerField.Create(Self);
  Itens_EntradaDatasetproduto_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetgrade_produto_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetproduto_nome := TStringField.Create(Self);
  Itens_EntradaDatasetmovimenta_estoque := TBooleanField.Create(Self);
  Itens_EntradaDatasetestoque_inicial := TFloatField.Create(Self);
  Itens_EntradaDatasetestoque_final := TFloatField.Create(Self);
  Itens_EntradaDatasetcfop_cfop := TStringField.Create(Self);
  Itens_EntradaDatasetunidade_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetquantidade := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_unitario := TFloatField.Create(Self);
  Itens_EntradaDatasetdesconto := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_desconto := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_total := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_icms := TFloatField.Create(Self);
  Itens_EntradaDataseticms := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms := TFloatField.Create(Self);
  Itens_EntradaDataseticms_dif := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_dif := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_st := TFloatField.Create(Self);
  Itens_EntradaDatasetst := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_st := TFloatField.Create(Self);
  Itens_EntradaDataseticms_red := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_red := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_ipi := TFloatField.Create(Self);
  Itens_EntradaDatasetipi := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_ipi := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_custo_unitario := TFloatField.Create(Self);
  Itens_EntradaDatasetlote_fabricacao := TStringField.Create(Self);
  Itens_EntradaDatasetdata_fabricacao := TDateTimeField.Create(Self);
  Itens_EntradaDatasetvalidade := TDateTimeField.Create(Self);
  Itens_EntradaDatasetdias_validade := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_frete := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_despensa_acessoria := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_seguro := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_outras := TFloatField.Create(Self);
  Itens_EntradaDatasetcst_id := TStringField.Create(Self);
  Itens_EntradaDatasetcst_ipi_id := TStringField.Create(Self);
  Itens_EntradaDatasetcst_pis_id := TStringField.Create(Self);
  Itens_EntradaDatasetcst_cofins_id := TStringField.Create(Self);
  Itens_EntradaDatasetcsosn_id := TStringField.Create(Self);
  Itens_EntradaDatasetorigem_csosn_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetquantidade_selo_ipi := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_base_issqn := TFloatField.Create(Self);
  Itens_EntradaDatasetissqn := TFloatField.Create(Self);
  Itens_EntradaDatasetcodigo_issqn := TStringField.Create(Self);
  Itens_EntradaDatasetvalor_issqn := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_pis := TFloatField.Create(Self);
  Itens_EntradaDatasetpis := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_pis := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_cofins := TFloatField.Create(Self);
  Itens_EntradaDatasetcofins := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_cofins := TFloatField.Create(Self);
  Itens_EntradaDatasetcodigo_bc_piscofins_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetcodigo_credito_piscofins_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_base_st_retida := TFloatField.Create(Self);
  Itens_EntradaDatasetst_retida := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_st_retida := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_pis_retido := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_cofins_retido := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_desconto_nota := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_total_liquido := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_total_impostos := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_frete_por_fora := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_outras_despesas := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_preco_custo := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_preco_venda := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_desonerado := TFloatField.Create(Self);
  Itens_EntradaDatasetdesoneracao_icms_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_icms_proprio_st := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_original := TFloatField.Create(Self);
  Itens_EntradaDatasetplano_contas_contabil_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetcodigo_interno := TIntegerField.Create(Self);
  Itens_EntradaDatasetexcluido := TBooleanField.Create(Self);
  Itens_EntradaDatasetinclusao := TDateTimeField.Create(Self);
  Itens_EntradaDatasetalteracao := TDateTimeField.Create(Self);
  Itens_EntradaDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientItens_EntradaGet := TXDataWebClient.Create(Self);
  XDataClientItens_EntradaDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcompra_id.BeforeLoadDFMValues;
  edcompra_id.BeforeLoadDFMValues;
  lbitem.BeforeLoadDFMValues;
  editem.BeforeLoadDFMValues;
  lbproduto_id.BeforeLoadDFMValues;
  edproduto_id.BeforeLoadDFMValues;
  lbgrade_produto_id.BeforeLoadDFMValues;
  edgrade_produto_id.BeforeLoadDFMValues;
  lbproduto_nome.BeforeLoadDFMValues;
  edproduto_nome.BeforeLoadDFMValues;
  lbmovimenta_estoque.BeforeLoadDFMValues;
  edmovimenta_estoque.BeforeLoadDFMValues;
  lbestoque_inicial.BeforeLoadDFMValues;
  edestoque_inicial.BeforeLoadDFMValues;
  lbestoque_final.BeforeLoadDFMValues;
  edestoque_final.BeforeLoadDFMValues;
  lbcfop_cfop.BeforeLoadDFMValues;
  edcfop_cfop.BeforeLoadDFMValues;
  lbunidade_id.BeforeLoadDFMValues;
  edunidade_id.BeforeLoadDFMValues;
  lbquantidade.BeforeLoadDFMValues;
  edquantidade.BeforeLoadDFMValues;
  lbvalor_unitario.BeforeLoadDFMValues;
  edvalor_unitario.BeforeLoadDFMValues;
  lbdesconto.BeforeLoadDFMValues;
  eddesconto.BeforeLoadDFMValues;
  lbvalor_desconto.BeforeLoadDFMValues;
  edvalor_desconto.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  lbvalor_base_icms.BeforeLoadDFMValues;
  edvalor_base_icms.BeforeLoadDFMValues;
  lbicms.BeforeLoadDFMValues;
  edicms.BeforeLoadDFMValues;
  lbvalor_icms.BeforeLoadDFMValues;
  edvalor_icms.BeforeLoadDFMValues;
  lbicms_dif.BeforeLoadDFMValues;
  edicms_dif.BeforeLoadDFMValues;
  lbvalor_icms_dif.BeforeLoadDFMValues;
  edvalor_icms_dif.BeforeLoadDFMValues;
  lbvalor_base_st.BeforeLoadDFMValues;
  edvalor_base_st.BeforeLoadDFMValues;
  lbst.BeforeLoadDFMValues;
  edst.BeforeLoadDFMValues;
  lbvalor_st.BeforeLoadDFMValues;
  edvalor_st.BeforeLoadDFMValues;
  lbicms_red.BeforeLoadDFMValues;
  edicms_red.BeforeLoadDFMValues;
  lbvalor_icms_red.BeforeLoadDFMValues;
  edvalor_icms_red.BeforeLoadDFMValues;
  lbvalor_base_ipi.BeforeLoadDFMValues;
  edvalor_base_ipi.BeforeLoadDFMValues;
  lbipi.BeforeLoadDFMValues;
  edipi.BeforeLoadDFMValues;
  lbvalor_ipi.BeforeLoadDFMValues;
  edvalor_ipi.BeforeLoadDFMValues;
  lbvalor_custo_unitario.BeforeLoadDFMValues;
  edvalor_custo_unitario.BeforeLoadDFMValues;
  lblote_fabricacao.BeforeLoadDFMValues;
  edlote_fabricacao.BeforeLoadDFMValues;
  lbdata_fabricacao.BeforeLoadDFMValues;
  eddata_fabricacao.BeforeLoadDFMValues;
  lbvalidade.BeforeLoadDFMValues;
  edvalidade.BeforeLoadDFMValues;
  lbdias_validade.BeforeLoadDFMValues;
  eddias_validade.BeforeLoadDFMValues;
  lbvalor_frete.BeforeLoadDFMValues;
  edvalor_frete.BeforeLoadDFMValues;
  lbvalor_despensa_acessoria.BeforeLoadDFMValues;
  edvalor_despensa_acessoria.BeforeLoadDFMValues;
  lbvalor_seguro.BeforeLoadDFMValues;
  edvalor_seguro.BeforeLoadDFMValues;
  lbvalor_outras.BeforeLoadDFMValues;
  edvalor_outras.BeforeLoadDFMValues;
  lbcst_id.BeforeLoadDFMValues;
  edcst_id.BeforeLoadDFMValues;
  lbcst_ipi_id.BeforeLoadDFMValues;
  edcst_ipi_id.BeforeLoadDFMValues;
  lbcst_pis_id.BeforeLoadDFMValues;
  edcst_pis_id.BeforeLoadDFMValues;
  lbcst_cofins_id.BeforeLoadDFMValues;
  edcst_cofins_id.BeforeLoadDFMValues;
  lbcsosn_id.BeforeLoadDFMValues;
  edcsosn_id.BeforeLoadDFMValues;
  lborigem_csosn_id.BeforeLoadDFMValues;
  edorigem_csosn_id.BeforeLoadDFMValues;
  lbquantidade_selo_ipi.BeforeLoadDFMValues;
  edquantidade_selo_ipi.BeforeLoadDFMValues;
  lbvalor_base_issqn.BeforeLoadDFMValues;
  edvalor_base_issqn.BeforeLoadDFMValues;
  lbissqn.BeforeLoadDFMValues;
  edissqn.BeforeLoadDFMValues;
  lbcodigo_issqn.BeforeLoadDFMValues;
  edcodigo_issqn.BeforeLoadDFMValues;
  lbvalor_issqn.BeforeLoadDFMValues;
  edvalor_issqn.BeforeLoadDFMValues;
  lbvalor_base_pis.BeforeLoadDFMValues;
  edvalor_base_pis.BeforeLoadDFMValues;
  lbpis.BeforeLoadDFMValues;
  edpis.BeforeLoadDFMValues;
  lbvalor_pis.BeforeLoadDFMValues;
  edvalor_pis.BeforeLoadDFMValues;
  lbvalor_base_cofins.BeforeLoadDFMValues;
  edvalor_base_cofins.BeforeLoadDFMValues;
  lbcofins.BeforeLoadDFMValues;
  edcofins.BeforeLoadDFMValues;
  lbvalor_cofins.BeforeLoadDFMValues;
  edvalor_cofins.BeforeLoadDFMValues;
  lbcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  edcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  lbcodigo_credito_piscofins_id.BeforeLoadDFMValues;
  edcodigo_credito_piscofins_id.BeforeLoadDFMValues;
  lbvalor_base_st_retida.BeforeLoadDFMValues;
  edvalor_base_st_retida.BeforeLoadDFMValues;
  lbst_retida.BeforeLoadDFMValues;
  edst_retida.BeforeLoadDFMValues;
  lbvalor_st_retida.BeforeLoadDFMValues;
  edvalor_st_retida.BeforeLoadDFMValues;
  lbvalor_pis_retido.BeforeLoadDFMValues;
  edvalor_pis_retido.BeforeLoadDFMValues;
  lbvalor_cofins_retido.BeforeLoadDFMValues;
  edvalor_cofins_retido.BeforeLoadDFMValues;
  lbvalor_desconto_nota.BeforeLoadDFMValues;
  edvalor_desconto_nota.BeforeLoadDFMValues;
  lbvalor_total_liquido.BeforeLoadDFMValues;
  edvalor_total_liquido.BeforeLoadDFMValues;
  lbvalor_total_impostos.BeforeLoadDFMValues;
  edvalor_total_impostos.BeforeLoadDFMValues;
  lbvalor_frete_por_fora.BeforeLoadDFMValues;
  edvalor_frete_por_fora.BeforeLoadDFMValues;
  lbvalor_outras_despesas.BeforeLoadDFMValues;
  edvalor_outras_despesas.BeforeLoadDFMValues;
  lbvalor_preco_custo.BeforeLoadDFMValues;
  edvalor_preco_custo.BeforeLoadDFMValues;
  lbvalor_preco_venda.BeforeLoadDFMValues;
  edvalor_preco_venda.BeforeLoadDFMValues;
  lbvalor_icms_desonerado.BeforeLoadDFMValues;
  edvalor_icms_desonerado.BeforeLoadDFMValues;
  lbdesoneracao_icms_id.BeforeLoadDFMValues;
  eddesoneracao_icms_id.BeforeLoadDFMValues;
  lbvalor_icms_proprio_st.BeforeLoadDFMValues;
  edvalor_icms_proprio_st.BeforeLoadDFMValues;
  lbvalor_icms_original.BeforeLoadDFMValues;
  edvalor_icms_original.BeforeLoadDFMValues;
  lbplano_contas_contabil_id.BeforeLoadDFMValues;
  edplano_contas_contabil_id.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Itens_EntradaDataset.BeforeLoadDFMValues;
  Itens_EntradaDatasetid.BeforeLoadDFMValues;
  Itens_EntradaDatasetaliado_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetdata_base_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcompra_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetitem.BeforeLoadDFMValues;
  Itens_EntradaDatasetproduto_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetgrade_produto_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetproduto_nome.BeforeLoadDFMValues;
  Itens_EntradaDatasetmovimenta_estoque.BeforeLoadDFMValues;
  Itens_EntradaDatasetestoque_inicial.BeforeLoadDFMValues;
  Itens_EntradaDatasetestoque_final.BeforeLoadDFMValues;
  Itens_EntradaDatasetcfop_cfop.BeforeLoadDFMValues;
  Itens_EntradaDatasetunidade_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetquantidade.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_unitario.BeforeLoadDFMValues;
  Itens_EntradaDatasetdesconto.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_desconto.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_total.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_icms.BeforeLoadDFMValues;
  Itens_EntradaDataseticms.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms.BeforeLoadDFMValues;
  Itens_EntradaDataseticms_dif.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_dif.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_st.BeforeLoadDFMValues;
  Itens_EntradaDatasetst.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_st.BeforeLoadDFMValues;
  Itens_EntradaDataseticms_red.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_red.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_ipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_ipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_custo_unitario.BeforeLoadDFMValues;
  Itens_EntradaDatasetlote_fabricacao.BeforeLoadDFMValues;
  Itens_EntradaDatasetdata_fabricacao.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalidade.BeforeLoadDFMValues;
  Itens_EntradaDatasetdias_validade.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_frete.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_despensa_acessoria.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_seguro.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_outras.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_ipi_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_pis_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_cofins_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcsosn_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetorigem_csosn_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetquantidade_selo_ipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_issqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetissqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_issqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_issqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_pis.BeforeLoadDFMValues;
  Itens_EntradaDatasetpis.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_pis.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_cofins.BeforeLoadDFMValues;
  Itens_EntradaDatasetcofins.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_cofins.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_credito_piscofins_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_st_retida.BeforeLoadDFMValues;
  Itens_EntradaDatasetst_retida.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_st_retida.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_pis_retido.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_cofins_retido.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_desconto_nota.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_total_liquido.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_total_impostos.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_frete_por_fora.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_outras_despesas.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_preco_custo.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_preco_venda.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_desonerado.BeforeLoadDFMValues;
  Itens_EntradaDatasetdesoneracao_icms_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_proprio_st.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_original.BeforeLoadDFMValues;
  Itens_EntradaDatasetplano_contas_contabil_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_interno.BeforeLoadDFMValues;
  Itens_EntradaDatasetexcluido.BeforeLoadDFMValues;
  Itens_EntradaDatasetinclusao.BeforeLoadDFMValues;
  Itens_EntradaDatasetalteracao.BeforeLoadDFMValues;
  Itens_EntradaDatasetexclusao.BeforeLoadDFMValues;
  XDataClientItens_EntradaGet.BeforeLoadDFMValues;
  XDataClientItens_EntradaDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewItens_EntradaEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 2452;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 2392;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 2392;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 2392;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcompra_id.SetParentComponent(Self);
    lbcompra_id.Name := 'lbcompra_id';
    lbcompra_id.Left := 24;
    lbcompra_id.Top := 273;
    lbcompra_id.Width := 14;
    lbcompra_id.Height := 13;
    lbcompra_id.Caption := 'compra_id:';
    lbcompra_id.Transparent := True;
    edcompra_id.SetParentComponent(Self);
    edcompra_id.Name := 'edcompra_id';
    edcompra_id.Left := 221;
    edcompra_id.Top := 270;
    edcompra_id.Width := 200;
    edcompra_id.Height := 21;
    edcompra_id.Enabled := True;
    edcompra_id.TabOrder := 9;
    edcompra_id.Text := 'edcompra_id';
    edcompra_id.DataField := 'compra_id';
    edcompra_id.DataSource := DataSource;
    lbitem.SetParentComponent(Self);
    lbitem.Name := 'lbitem';
    lbitem.Left := 24;
    lbitem.Top := 300;
    lbitem.Width := 14;
    lbitem.Height := 13;
    lbitem.Caption := 'item:';
    lbitem.Transparent := True;
    editem.SetParentComponent(Self);
    editem.Name := 'editem';
    editem.Left := 221;
    editem.Top := 297;
    editem.Width := 200;
    editem.Height := 21;
    editem.Enabled := True;
    editem.TabOrder := 10;
    editem.Text := 'editem';
    editem.DataField := 'item';
    editem.DataSource := DataSource;
    lbproduto_id.SetParentComponent(Self);
    lbproduto_id.Name := 'lbproduto_id';
    lbproduto_id.Left := 24;
    lbproduto_id.Top := 327;
    lbproduto_id.Width := 14;
    lbproduto_id.Height := 13;
    lbproduto_id.Caption := 'produto_id:';
    lbproduto_id.Transparent := True;
    edproduto_id.SetParentComponent(Self);
    edproduto_id.Name := 'edproduto_id';
    edproduto_id.Left := 221;
    edproduto_id.Top := 324;
    edproduto_id.Width := 200;
    edproduto_id.Height := 21;
    edproduto_id.Enabled := True;
    edproduto_id.TabOrder := 11;
    edproduto_id.Text := 'edproduto_id';
    edproduto_id.DataField := 'produto_id';
    edproduto_id.DataSource := DataSource;
    lbgrade_produto_id.SetParentComponent(Self);
    lbgrade_produto_id.Name := 'lbgrade_produto_id';
    lbgrade_produto_id.Left := 24;
    lbgrade_produto_id.Top := 354;
    lbgrade_produto_id.Width := 14;
    lbgrade_produto_id.Height := 13;
    lbgrade_produto_id.Caption := 'grade_produto_id:';
    lbgrade_produto_id.Transparent := True;
    edgrade_produto_id.SetParentComponent(Self);
    edgrade_produto_id.Name := 'edgrade_produto_id';
    edgrade_produto_id.Left := 221;
    edgrade_produto_id.Top := 351;
    edgrade_produto_id.Width := 200;
    edgrade_produto_id.Height := 21;
    edgrade_produto_id.Enabled := True;
    edgrade_produto_id.TabOrder := 12;
    edgrade_produto_id.Text := 'edgrade_produto_id';
    edgrade_produto_id.DataField := 'grade_produto_id';
    edgrade_produto_id.DataSource := DataSource;
    lbproduto_nome.SetParentComponent(Self);
    lbproduto_nome.Name := 'lbproduto_nome';
    lbproduto_nome.Left := 24;
    lbproduto_nome.Top := 381;
    lbproduto_nome.Width := 14;
    lbproduto_nome.Height := 13;
    lbproduto_nome.Caption := 'produto_nome:';
    lbproduto_nome.Transparent := True;
    edproduto_nome.SetParentComponent(Self);
    edproduto_nome.Name := 'edproduto_nome';
    edproduto_nome.Left := 221;
    edproduto_nome.Top := 378;
    edproduto_nome.Width := 200;
    edproduto_nome.Height := 21;
    edproduto_nome.Enabled := True;
    edproduto_nome.TabOrder := 13;
    edproduto_nome.Text := 'edproduto_nome';
    edproduto_nome.DataField := 'produto_nome';
    edproduto_nome.DataSource := DataSource;
    lbmovimenta_estoque.SetParentComponent(Self);
    lbmovimenta_estoque.Name := 'lbmovimenta_estoque';
    lbmovimenta_estoque.Left := 24;
    lbmovimenta_estoque.Top := 408;
    lbmovimenta_estoque.Width := 14;
    lbmovimenta_estoque.Height := 13;
    lbmovimenta_estoque.Caption := 'movimenta_estoque:';
    lbmovimenta_estoque.Transparent := True;
    edmovimenta_estoque.SetParentComponent(Self);
    edmovimenta_estoque.Name := 'edmovimenta_estoque';
    edmovimenta_estoque.Left := 221;
    edmovimenta_estoque.Top := 405;
    edmovimenta_estoque.Width := 200;
    edmovimenta_estoque.Height := 21;
    edmovimenta_estoque.Enabled := True;
    edmovimenta_estoque.TabOrder := 14;
    edmovimenta_estoque.Text := 'edmovimenta_estoque';
    edmovimenta_estoque.DataField := 'movimenta_estoque';
    edmovimenta_estoque.DataSource := DataSource;
    lbestoque_inicial.SetParentComponent(Self);
    lbestoque_inicial.Name := 'lbestoque_inicial';
    lbestoque_inicial.Left := 24;
    lbestoque_inicial.Top := 435;
    lbestoque_inicial.Width := 14;
    lbestoque_inicial.Height := 13;
    lbestoque_inicial.Caption := 'estoque_inicial:';
    lbestoque_inicial.Transparent := True;
    edestoque_inicial.SetParentComponent(Self);
    edestoque_inicial.Name := 'edestoque_inicial';
    edestoque_inicial.Left := 221;
    edestoque_inicial.Top := 432;
    edestoque_inicial.Width := 200;
    edestoque_inicial.Height := 21;
    edestoque_inicial.Enabled := True;
    edestoque_inicial.TabOrder := 15;
    edestoque_inicial.Text := 'edestoque_inicial';
    edestoque_inicial.DataField := 'estoque_inicial';
    edestoque_inicial.DataSource := DataSource;
    lbestoque_final.SetParentComponent(Self);
    lbestoque_final.Name := 'lbestoque_final';
    lbestoque_final.Left := 24;
    lbestoque_final.Top := 462;
    lbestoque_final.Width := 14;
    lbestoque_final.Height := 13;
    lbestoque_final.Caption := 'estoque_final:';
    lbestoque_final.Transparent := True;
    edestoque_final.SetParentComponent(Self);
    edestoque_final.Name := 'edestoque_final';
    edestoque_final.Left := 221;
    edestoque_final.Top := 459;
    edestoque_final.Width := 200;
    edestoque_final.Height := 21;
    edestoque_final.Enabled := True;
    edestoque_final.TabOrder := 16;
    edestoque_final.Text := 'edestoque_final';
    edestoque_final.DataField := 'estoque_final';
    edestoque_final.DataSource := DataSource;
    lbcfop_cfop.SetParentComponent(Self);
    lbcfop_cfop.Name := 'lbcfop_cfop';
    lbcfop_cfop.Left := 24;
    lbcfop_cfop.Top := 489;
    lbcfop_cfop.Width := 14;
    lbcfop_cfop.Height := 13;
    lbcfop_cfop.Caption := 'cfop_cfop:';
    lbcfop_cfop.Transparent := True;
    edcfop_cfop.SetParentComponent(Self);
    edcfop_cfop.Name := 'edcfop_cfop';
    edcfop_cfop.Left := 221;
    edcfop_cfop.Top := 486;
    edcfop_cfop.Width := 200;
    edcfop_cfop.Height := 21;
    edcfop_cfop.Enabled := True;
    edcfop_cfop.TabOrder := 17;
    edcfop_cfop.Text := 'edcfop_cfop';
    edcfop_cfop.DataField := 'cfop_cfop';
    edcfop_cfop.DataSource := DataSource;
    lbunidade_id.SetParentComponent(Self);
    lbunidade_id.Name := 'lbunidade_id';
    lbunidade_id.Left := 24;
    lbunidade_id.Top := 516;
    lbunidade_id.Width := 14;
    lbunidade_id.Height := 13;
    lbunidade_id.Caption := 'unidade_id:';
    lbunidade_id.Transparent := True;
    edunidade_id.SetParentComponent(Self);
    edunidade_id.Name := 'edunidade_id';
    edunidade_id.Left := 221;
    edunidade_id.Top := 513;
    edunidade_id.Width := 200;
    edunidade_id.Height := 21;
    edunidade_id.Enabled := True;
    edunidade_id.TabOrder := 18;
    edunidade_id.Text := 'edunidade_id';
    edunidade_id.DataField := 'unidade_id';
    edunidade_id.DataSource := DataSource;
    lbquantidade.SetParentComponent(Self);
    lbquantidade.Name := 'lbquantidade';
    lbquantidade.Left := 24;
    lbquantidade.Top := 543;
    lbquantidade.Width := 14;
    lbquantidade.Height := 13;
    lbquantidade.Caption := 'quantidade:';
    lbquantidade.Transparent := True;
    edquantidade.SetParentComponent(Self);
    edquantidade.Name := 'edquantidade';
    edquantidade.Left := 221;
    edquantidade.Top := 540;
    edquantidade.Width := 200;
    edquantidade.Height := 21;
    edquantidade.Enabled := True;
    edquantidade.TabOrder := 19;
    edquantidade.Text := 'edquantidade';
    edquantidade.DataField := 'quantidade';
    edquantidade.DataSource := DataSource;
    lbvalor_unitario.SetParentComponent(Self);
    lbvalor_unitario.Name := 'lbvalor_unitario';
    lbvalor_unitario.Left := 24;
    lbvalor_unitario.Top := 570;
    lbvalor_unitario.Width := 14;
    lbvalor_unitario.Height := 13;
    lbvalor_unitario.Caption := 'valor_unitario:';
    lbvalor_unitario.Transparent := True;
    edvalor_unitario.SetParentComponent(Self);
    edvalor_unitario.Name := 'edvalor_unitario';
    edvalor_unitario.Left := 221;
    edvalor_unitario.Top := 567;
    edvalor_unitario.Width := 200;
    edvalor_unitario.Height := 21;
    edvalor_unitario.Enabled := True;
    edvalor_unitario.TabOrder := 20;
    edvalor_unitario.Text := 'edvalor_unitario';
    edvalor_unitario.DataField := 'valor_unitario';
    edvalor_unitario.DataSource := DataSource;
    lbdesconto.SetParentComponent(Self);
    lbdesconto.Name := 'lbdesconto';
    lbdesconto.Left := 24;
    lbdesconto.Top := 597;
    lbdesconto.Width := 14;
    lbdesconto.Height := 13;
    lbdesconto.Caption := 'desconto:';
    lbdesconto.Transparent := True;
    eddesconto.SetParentComponent(Self);
    eddesconto.Name := 'eddesconto';
    eddesconto.Left := 221;
    eddesconto.Top := 594;
    eddesconto.Width := 200;
    eddesconto.Height := 21;
    eddesconto.Enabled := True;
    eddesconto.TabOrder := 21;
    eddesconto.Text := 'eddesconto';
    eddesconto.DataField := 'desconto';
    eddesconto.DataSource := DataSource;
    lbvalor_desconto.SetParentComponent(Self);
    lbvalor_desconto.Name := 'lbvalor_desconto';
    lbvalor_desconto.Left := 24;
    lbvalor_desconto.Top := 624;
    lbvalor_desconto.Width := 14;
    lbvalor_desconto.Height := 13;
    lbvalor_desconto.Caption := 'valor_desconto:';
    lbvalor_desconto.Transparent := True;
    edvalor_desconto.SetParentComponent(Self);
    edvalor_desconto.Name := 'edvalor_desconto';
    edvalor_desconto.Left := 221;
    edvalor_desconto.Top := 621;
    edvalor_desconto.Width := 200;
    edvalor_desconto.Height := 21;
    edvalor_desconto.Enabled := True;
    edvalor_desconto.TabOrder := 22;
    edvalor_desconto.Text := 'edvalor_desconto';
    edvalor_desconto.DataField := 'valor_desconto';
    edvalor_desconto.DataSource := DataSource;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 24;
    lbvalor_total.Top := 651;
    lbvalor_total.Width := 14;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'valor_total:';
    lbvalor_total.Transparent := True;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 221;
    edvalor_total.Top := 648;
    edvalor_total.Width := 200;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := True;
    edvalor_total.TabOrder := 23;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    lbvalor_base_icms.SetParentComponent(Self);
    lbvalor_base_icms.Name := 'lbvalor_base_icms';
    lbvalor_base_icms.Left := 24;
    lbvalor_base_icms.Top := 678;
    lbvalor_base_icms.Width := 14;
    lbvalor_base_icms.Height := 13;
    lbvalor_base_icms.Caption := 'valor_base_icms:';
    lbvalor_base_icms.Transparent := True;
    edvalor_base_icms.SetParentComponent(Self);
    edvalor_base_icms.Name := 'edvalor_base_icms';
    edvalor_base_icms.Left := 221;
    edvalor_base_icms.Top := 675;
    edvalor_base_icms.Width := 200;
    edvalor_base_icms.Height := 21;
    edvalor_base_icms.Enabled := True;
    edvalor_base_icms.TabOrder := 24;
    edvalor_base_icms.Text := 'edvalor_base_icms';
    edvalor_base_icms.DataField := 'valor_base_icms';
    edvalor_base_icms.DataSource := DataSource;
    lbicms.SetParentComponent(Self);
    lbicms.Name := 'lbicms';
    lbicms.Left := 24;
    lbicms.Top := 705;
    lbicms.Width := 14;
    lbicms.Height := 13;
    lbicms.Caption := 'icms:';
    lbicms.Transparent := True;
    edicms.SetParentComponent(Self);
    edicms.Name := 'edicms';
    edicms.Left := 221;
    edicms.Top := 702;
    edicms.Width := 200;
    edicms.Height := 21;
    edicms.Enabled := True;
    edicms.TabOrder := 25;
    edicms.Text := 'edicms';
    edicms.DataField := 'icms';
    edicms.DataSource := DataSource;
    lbvalor_icms.SetParentComponent(Self);
    lbvalor_icms.Name := 'lbvalor_icms';
    lbvalor_icms.Left := 24;
    lbvalor_icms.Top := 732;
    lbvalor_icms.Width := 14;
    lbvalor_icms.Height := 13;
    lbvalor_icms.Caption := 'valor_icms:';
    lbvalor_icms.Transparent := True;
    edvalor_icms.SetParentComponent(Self);
    edvalor_icms.Name := 'edvalor_icms';
    edvalor_icms.Left := 221;
    edvalor_icms.Top := 729;
    edvalor_icms.Width := 200;
    edvalor_icms.Height := 21;
    edvalor_icms.Enabled := True;
    edvalor_icms.TabOrder := 26;
    edvalor_icms.Text := 'edvalor_icms';
    edvalor_icms.DataField := 'valor_icms';
    edvalor_icms.DataSource := DataSource;
    lbicms_dif.SetParentComponent(Self);
    lbicms_dif.Name := 'lbicms_dif';
    lbicms_dif.Left := 24;
    lbicms_dif.Top := 759;
    lbicms_dif.Width := 14;
    lbicms_dif.Height := 13;
    lbicms_dif.Caption := 'icms_dif:';
    lbicms_dif.Transparent := True;
    edicms_dif.SetParentComponent(Self);
    edicms_dif.Name := 'edicms_dif';
    edicms_dif.Left := 221;
    edicms_dif.Top := 756;
    edicms_dif.Width := 200;
    edicms_dif.Height := 21;
    edicms_dif.Enabled := True;
    edicms_dif.TabOrder := 27;
    edicms_dif.Text := 'edicms_dif';
    edicms_dif.DataField := 'icms_dif';
    edicms_dif.DataSource := DataSource;
    lbvalor_icms_dif.SetParentComponent(Self);
    lbvalor_icms_dif.Name := 'lbvalor_icms_dif';
    lbvalor_icms_dif.Left := 24;
    lbvalor_icms_dif.Top := 786;
    lbvalor_icms_dif.Width := 14;
    lbvalor_icms_dif.Height := 13;
    lbvalor_icms_dif.Caption := 'valor_icms_dif:';
    lbvalor_icms_dif.Transparent := True;
    edvalor_icms_dif.SetParentComponent(Self);
    edvalor_icms_dif.Name := 'edvalor_icms_dif';
    edvalor_icms_dif.Left := 221;
    edvalor_icms_dif.Top := 783;
    edvalor_icms_dif.Width := 200;
    edvalor_icms_dif.Height := 21;
    edvalor_icms_dif.Enabled := True;
    edvalor_icms_dif.TabOrder := 28;
    edvalor_icms_dif.Text := 'edvalor_icms_dif';
    edvalor_icms_dif.DataField := 'valor_icms_dif';
    edvalor_icms_dif.DataSource := DataSource;
    lbvalor_base_st.SetParentComponent(Self);
    lbvalor_base_st.Name := 'lbvalor_base_st';
    lbvalor_base_st.Left := 24;
    lbvalor_base_st.Top := 813;
    lbvalor_base_st.Width := 14;
    lbvalor_base_st.Height := 13;
    lbvalor_base_st.Caption := 'valor_base_st:';
    lbvalor_base_st.Transparent := True;
    edvalor_base_st.SetParentComponent(Self);
    edvalor_base_st.Name := 'edvalor_base_st';
    edvalor_base_st.Left := 221;
    edvalor_base_st.Top := 810;
    edvalor_base_st.Width := 200;
    edvalor_base_st.Height := 21;
    edvalor_base_st.Enabled := True;
    edvalor_base_st.TabOrder := 29;
    edvalor_base_st.Text := 'edvalor_base_st';
    edvalor_base_st.DataField := 'valor_base_st';
    edvalor_base_st.DataSource := DataSource;
    lbst.SetParentComponent(Self);
    lbst.Name := 'lbst';
    lbst.Left := 24;
    lbst.Top := 840;
    lbst.Width := 14;
    lbst.Height := 13;
    lbst.Caption := 'st:';
    lbst.Transparent := True;
    edst.SetParentComponent(Self);
    edst.Name := 'edst';
    edst.Left := 221;
    edst.Top := 837;
    edst.Width := 200;
    edst.Height := 21;
    edst.Enabled := True;
    edst.TabOrder := 30;
    edst.Text := 'edst';
    edst.DataField := 'st';
    edst.DataSource := DataSource;
    lbvalor_st.SetParentComponent(Self);
    lbvalor_st.Name := 'lbvalor_st';
    lbvalor_st.Left := 24;
    lbvalor_st.Top := 867;
    lbvalor_st.Width := 14;
    lbvalor_st.Height := 13;
    lbvalor_st.Caption := 'valor_st:';
    lbvalor_st.Transparent := True;
    edvalor_st.SetParentComponent(Self);
    edvalor_st.Name := 'edvalor_st';
    edvalor_st.Left := 221;
    edvalor_st.Top := 864;
    edvalor_st.Width := 200;
    edvalor_st.Height := 21;
    edvalor_st.Enabled := True;
    edvalor_st.TabOrder := 31;
    edvalor_st.Text := 'edvalor_st';
    edvalor_st.DataField := 'valor_st';
    edvalor_st.DataSource := DataSource;
    lbicms_red.SetParentComponent(Self);
    lbicms_red.Name := 'lbicms_red';
    lbicms_red.Left := 24;
    lbicms_red.Top := 894;
    lbicms_red.Width := 14;
    lbicms_red.Height := 13;
    lbicms_red.Caption := 'icms_red:';
    lbicms_red.Transparent := True;
    edicms_red.SetParentComponent(Self);
    edicms_red.Name := 'edicms_red';
    edicms_red.Left := 221;
    edicms_red.Top := 891;
    edicms_red.Width := 200;
    edicms_red.Height := 21;
    edicms_red.Enabled := True;
    edicms_red.TabOrder := 32;
    edicms_red.Text := 'edicms_red';
    edicms_red.DataField := 'icms_red';
    edicms_red.DataSource := DataSource;
    lbvalor_icms_red.SetParentComponent(Self);
    lbvalor_icms_red.Name := 'lbvalor_icms_red';
    lbvalor_icms_red.Left := 24;
    lbvalor_icms_red.Top := 921;
    lbvalor_icms_red.Width := 14;
    lbvalor_icms_red.Height := 13;
    lbvalor_icms_red.Caption := 'valor_icms_red:';
    lbvalor_icms_red.Transparent := True;
    edvalor_icms_red.SetParentComponent(Self);
    edvalor_icms_red.Name := 'edvalor_icms_red';
    edvalor_icms_red.Left := 221;
    edvalor_icms_red.Top := 918;
    edvalor_icms_red.Width := 200;
    edvalor_icms_red.Height := 21;
    edvalor_icms_red.Enabled := True;
    edvalor_icms_red.TabOrder := 33;
    edvalor_icms_red.Text := 'edvalor_icms_red';
    edvalor_icms_red.DataField := 'valor_icms_red';
    edvalor_icms_red.DataSource := DataSource;
    lbvalor_base_ipi.SetParentComponent(Self);
    lbvalor_base_ipi.Name := 'lbvalor_base_ipi';
    lbvalor_base_ipi.Left := 24;
    lbvalor_base_ipi.Top := 948;
    lbvalor_base_ipi.Width := 14;
    lbvalor_base_ipi.Height := 13;
    lbvalor_base_ipi.Caption := 'valor_base_ipi:';
    lbvalor_base_ipi.Transparent := True;
    edvalor_base_ipi.SetParentComponent(Self);
    edvalor_base_ipi.Name := 'edvalor_base_ipi';
    edvalor_base_ipi.Left := 221;
    edvalor_base_ipi.Top := 945;
    edvalor_base_ipi.Width := 200;
    edvalor_base_ipi.Height := 21;
    edvalor_base_ipi.Enabled := True;
    edvalor_base_ipi.TabOrder := 34;
    edvalor_base_ipi.Text := 'edvalor_base_ipi';
    edvalor_base_ipi.DataField := 'valor_base_ipi';
    edvalor_base_ipi.DataSource := DataSource;
    lbipi.SetParentComponent(Self);
    lbipi.Name := 'lbipi';
    lbipi.Left := 24;
    lbipi.Top := 975;
    lbipi.Width := 14;
    lbipi.Height := 13;
    lbipi.Caption := 'ipi:';
    lbipi.Transparent := True;
    edipi.SetParentComponent(Self);
    edipi.Name := 'edipi';
    edipi.Left := 221;
    edipi.Top := 972;
    edipi.Width := 200;
    edipi.Height := 21;
    edipi.Enabled := True;
    edipi.TabOrder := 35;
    edipi.Text := 'edipi';
    edipi.DataField := 'ipi';
    edipi.DataSource := DataSource;
    lbvalor_ipi.SetParentComponent(Self);
    lbvalor_ipi.Name := 'lbvalor_ipi';
    lbvalor_ipi.Left := 24;
    lbvalor_ipi.Top := 1002;
    lbvalor_ipi.Width := 14;
    lbvalor_ipi.Height := 13;
    lbvalor_ipi.Caption := 'valor_ipi:';
    lbvalor_ipi.Transparent := True;
    edvalor_ipi.SetParentComponent(Self);
    edvalor_ipi.Name := 'edvalor_ipi';
    edvalor_ipi.Left := 221;
    edvalor_ipi.Top := 999;
    edvalor_ipi.Width := 200;
    edvalor_ipi.Height := 21;
    edvalor_ipi.Enabled := True;
    edvalor_ipi.TabOrder := 36;
    edvalor_ipi.Text := 'edvalor_ipi';
    edvalor_ipi.DataField := 'valor_ipi';
    edvalor_ipi.DataSource := DataSource;
    lbvalor_custo_unitario.SetParentComponent(Self);
    lbvalor_custo_unitario.Name := 'lbvalor_custo_unitario';
    lbvalor_custo_unitario.Left := 24;
    lbvalor_custo_unitario.Top := 1029;
    lbvalor_custo_unitario.Width := 14;
    lbvalor_custo_unitario.Height := 13;
    lbvalor_custo_unitario.Caption := 'valor_custo_unitario:';
    lbvalor_custo_unitario.Transparent := True;
    edvalor_custo_unitario.SetParentComponent(Self);
    edvalor_custo_unitario.Name := 'edvalor_custo_unitario';
    edvalor_custo_unitario.Left := 221;
    edvalor_custo_unitario.Top := 1026;
    edvalor_custo_unitario.Width := 200;
    edvalor_custo_unitario.Height := 21;
    edvalor_custo_unitario.Enabled := True;
    edvalor_custo_unitario.TabOrder := 37;
    edvalor_custo_unitario.Text := 'edvalor_custo_unitario';
    edvalor_custo_unitario.DataField := 'valor_custo_unitario';
    edvalor_custo_unitario.DataSource := DataSource;
    lblote_fabricacao.SetParentComponent(Self);
    lblote_fabricacao.Name := 'lblote_fabricacao';
    lblote_fabricacao.Left := 24;
    lblote_fabricacao.Top := 1056;
    lblote_fabricacao.Width := 14;
    lblote_fabricacao.Height := 13;
    lblote_fabricacao.Caption := 'lote_fabricacao:';
    lblote_fabricacao.Transparent := True;
    edlote_fabricacao.SetParentComponent(Self);
    edlote_fabricacao.Name := 'edlote_fabricacao';
    edlote_fabricacao.Left := 221;
    edlote_fabricacao.Top := 1053;
    edlote_fabricacao.Width := 200;
    edlote_fabricacao.Height := 21;
    edlote_fabricacao.Enabled := True;
    edlote_fabricacao.TabOrder := 38;
    edlote_fabricacao.Text := 'edlote_fabricacao';
    edlote_fabricacao.DataField := 'lote_fabricacao';
    edlote_fabricacao.DataSource := DataSource;
    lbdata_fabricacao.SetParentComponent(Self);
    lbdata_fabricacao.Name := 'lbdata_fabricacao';
    lbdata_fabricacao.Left := 24;
    lbdata_fabricacao.Top := 1083;
    lbdata_fabricacao.Width := 14;
    lbdata_fabricacao.Height := 13;
    lbdata_fabricacao.Caption := 'data_fabricacao:';
    lbdata_fabricacao.Transparent := True;
    eddata_fabricacao.SetParentComponent(Self);
    eddata_fabricacao.Name := 'eddata_fabricacao';
    eddata_fabricacao.Left := 221;
    eddata_fabricacao.Top := 1080;
    eddata_fabricacao.Width := 200;
    eddata_fabricacao.Height := 21;
    eddata_fabricacao.Enabled := True;
    eddata_fabricacao.TabOrder := 39;
    eddata_fabricacao.Text := 'eddata_fabricacao';
    eddata_fabricacao.DataField := 'data_fabricacao';
    eddata_fabricacao.DataSource := DataSource;
    lbvalidade.SetParentComponent(Self);
    lbvalidade.Name := 'lbvalidade';
    lbvalidade.Left := 24;
    lbvalidade.Top := 1110;
    lbvalidade.Width := 14;
    lbvalidade.Height := 13;
    lbvalidade.Caption := 'validade:';
    lbvalidade.Transparent := True;
    edvalidade.SetParentComponent(Self);
    edvalidade.Name := 'edvalidade';
    edvalidade.Left := 221;
    edvalidade.Top := 1107;
    edvalidade.Width := 200;
    edvalidade.Height := 21;
    edvalidade.Enabled := True;
    edvalidade.TabOrder := 40;
    edvalidade.Text := 'edvalidade';
    edvalidade.DataField := 'validade';
    edvalidade.DataSource := DataSource;
    lbdias_validade.SetParentComponent(Self);
    lbdias_validade.Name := 'lbdias_validade';
    lbdias_validade.Left := 24;
    lbdias_validade.Top := 1137;
    lbdias_validade.Width := 14;
    lbdias_validade.Height := 13;
    lbdias_validade.Caption := 'dias_validade:';
    lbdias_validade.Transparent := True;
    eddias_validade.SetParentComponent(Self);
    eddias_validade.Name := 'eddias_validade';
    eddias_validade.Left := 221;
    eddias_validade.Top := 1134;
    eddias_validade.Width := 200;
    eddias_validade.Height := 21;
    eddias_validade.Enabled := True;
    eddias_validade.TabOrder := 41;
    eddias_validade.Text := 'eddias_validade';
    eddias_validade.DataField := 'dias_validade';
    eddias_validade.DataSource := DataSource;
    lbvalor_frete.SetParentComponent(Self);
    lbvalor_frete.Name := 'lbvalor_frete';
    lbvalor_frete.Left := 24;
    lbvalor_frete.Top := 1164;
    lbvalor_frete.Width := 14;
    lbvalor_frete.Height := 13;
    lbvalor_frete.Caption := 'valor_frete:';
    lbvalor_frete.Transparent := True;
    edvalor_frete.SetParentComponent(Self);
    edvalor_frete.Name := 'edvalor_frete';
    edvalor_frete.Left := 221;
    edvalor_frete.Top := 1161;
    edvalor_frete.Width := 200;
    edvalor_frete.Height := 21;
    edvalor_frete.Enabled := True;
    edvalor_frete.TabOrder := 42;
    edvalor_frete.Text := 'edvalor_frete';
    edvalor_frete.DataField := 'valor_frete';
    edvalor_frete.DataSource := DataSource;
    lbvalor_despensa_acessoria.SetParentComponent(Self);
    lbvalor_despensa_acessoria.Name := 'lbvalor_despensa_acessoria';
    lbvalor_despensa_acessoria.Left := 24;
    lbvalor_despensa_acessoria.Top := 1191;
    lbvalor_despensa_acessoria.Width := 14;
    lbvalor_despensa_acessoria.Height := 13;
    lbvalor_despensa_acessoria.Caption := 'valor_despensa_acessoria:';
    lbvalor_despensa_acessoria.Transparent := True;
    edvalor_despensa_acessoria.SetParentComponent(Self);
    edvalor_despensa_acessoria.Name := 'edvalor_despensa_acessoria';
    edvalor_despensa_acessoria.Left := 221;
    edvalor_despensa_acessoria.Top := 1188;
    edvalor_despensa_acessoria.Width := 200;
    edvalor_despensa_acessoria.Height := 21;
    edvalor_despensa_acessoria.Enabled := True;
    edvalor_despensa_acessoria.TabOrder := 43;
    edvalor_despensa_acessoria.Text := 'edvalor_despensa_acessoria';
    edvalor_despensa_acessoria.DataField := 'valor_despensa_acessoria';
    edvalor_despensa_acessoria.DataSource := DataSource;
    lbvalor_seguro.SetParentComponent(Self);
    lbvalor_seguro.Name := 'lbvalor_seguro';
    lbvalor_seguro.Left := 24;
    lbvalor_seguro.Top := 1218;
    lbvalor_seguro.Width := 14;
    lbvalor_seguro.Height := 13;
    lbvalor_seguro.Caption := 'valor_seguro:';
    lbvalor_seguro.Transparent := True;
    edvalor_seguro.SetParentComponent(Self);
    edvalor_seguro.Name := 'edvalor_seguro';
    edvalor_seguro.Left := 221;
    edvalor_seguro.Top := 1215;
    edvalor_seguro.Width := 200;
    edvalor_seguro.Height := 21;
    edvalor_seguro.Enabled := True;
    edvalor_seguro.TabOrder := 44;
    edvalor_seguro.Text := 'edvalor_seguro';
    edvalor_seguro.DataField := 'valor_seguro';
    edvalor_seguro.DataSource := DataSource;
    lbvalor_outras.SetParentComponent(Self);
    lbvalor_outras.Name := 'lbvalor_outras';
    lbvalor_outras.Left := 24;
    lbvalor_outras.Top := 1245;
    lbvalor_outras.Width := 14;
    lbvalor_outras.Height := 13;
    lbvalor_outras.Caption := 'valor_outras:';
    lbvalor_outras.Transparent := True;
    edvalor_outras.SetParentComponent(Self);
    edvalor_outras.Name := 'edvalor_outras';
    edvalor_outras.Left := 221;
    edvalor_outras.Top := 1242;
    edvalor_outras.Width := 200;
    edvalor_outras.Height := 21;
    edvalor_outras.Enabled := True;
    edvalor_outras.TabOrder := 45;
    edvalor_outras.Text := 'edvalor_outras';
    edvalor_outras.DataField := 'valor_outras';
    edvalor_outras.DataSource := DataSource;
    lbcst_id.SetParentComponent(Self);
    lbcst_id.Name := 'lbcst_id';
    lbcst_id.Left := 24;
    lbcst_id.Top := 1272;
    lbcst_id.Width := 14;
    lbcst_id.Height := 13;
    lbcst_id.Caption := 'cst_id:';
    lbcst_id.Transparent := True;
    edcst_id.SetParentComponent(Self);
    edcst_id.Name := 'edcst_id';
    edcst_id.Left := 221;
    edcst_id.Top := 1269;
    edcst_id.Width := 200;
    edcst_id.Height := 21;
    edcst_id.Enabled := True;
    edcst_id.TabOrder := 46;
    edcst_id.Text := 'edcst_id';
    edcst_id.DataField := 'cst_id';
    edcst_id.DataSource := DataSource;
    lbcst_ipi_id.SetParentComponent(Self);
    lbcst_ipi_id.Name := 'lbcst_ipi_id';
    lbcst_ipi_id.Left := 24;
    lbcst_ipi_id.Top := 1299;
    lbcst_ipi_id.Width := 14;
    lbcst_ipi_id.Height := 13;
    lbcst_ipi_id.Caption := 'cst_ipi_id:';
    lbcst_ipi_id.Transparent := True;
    edcst_ipi_id.SetParentComponent(Self);
    edcst_ipi_id.Name := 'edcst_ipi_id';
    edcst_ipi_id.Left := 221;
    edcst_ipi_id.Top := 1296;
    edcst_ipi_id.Width := 200;
    edcst_ipi_id.Height := 21;
    edcst_ipi_id.Enabled := True;
    edcst_ipi_id.TabOrder := 47;
    edcst_ipi_id.Text := 'edcst_ipi_id';
    edcst_ipi_id.DataField := 'cst_ipi_id';
    edcst_ipi_id.DataSource := DataSource;
    lbcst_pis_id.SetParentComponent(Self);
    lbcst_pis_id.Name := 'lbcst_pis_id';
    lbcst_pis_id.Left := 24;
    lbcst_pis_id.Top := 1326;
    lbcst_pis_id.Width := 14;
    lbcst_pis_id.Height := 13;
    lbcst_pis_id.Caption := 'cst_pis_id:';
    lbcst_pis_id.Transparent := True;
    edcst_pis_id.SetParentComponent(Self);
    edcst_pis_id.Name := 'edcst_pis_id';
    edcst_pis_id.Left := 221;
    edcst_pis_id.Top := 1323;
    edcst_pis_id.Width := 200;
    edcst_pis_id.Height := 21;
    edcst_pis_id.Enabled := True;
    edcst_pis_id.TabOrder := 48;
    edcst_pis_id.Text := 'edcst_pis_id';
    edcst_pis_id.DataField := 'cst_pis_id';
    edcst_pis_id.DataSource := DataSource;
    lbcst_cofins_id.SetParentComponent(Self);
    lbcst_cofins_id.Name := 'lbcst_cofins_id';
    lbcst_cofins_id.Left := 24;
    lbcst_cofins_id.Top := 1353;
    lbcst_cofins_id.Width := 14;
    lbcst_cofins_id.Height := 13;
    lbcst_cofins_id.Caption := 'cst_cofins_id:';
    lbcst_cofins_id.Transparent := True;
    edcst_cofins_id.SetParentComponent(Self);
    edcst_cofins_id.Name := 'edcst_cofins_id';
    edcst_cofins_id.Left := 221;
    edcst_cofins_id.Top := 1350;
    edcst_cofins_id.Width := 200;
    edcst_cofins_id.Height := 21;
    edcst_cofins_id.Enabled := True;
    edcst_cofins_id.TabOrder := 49;
    edcst_cofins_id.Text := 'edcst_cofins_id';
    edcst_cofins_id.DataField := 'cst_cofins_id';
    edcst_cofins_id.DataSource := DataSource;
    lbcsosn_id.SetParentComponent(Self);
    lbcsosn_id.Name := 'lbcsosn_id';
    lbcsosn_id.Left := 24;
    lbcsosn_id.Top := 1380;
    lbcsosn_id.Width := 14;
    lbcsosn_id.Height := 13;
    lbcsosn_id.Caption := 'csosn_id:';
    lbcsosn_id.Transparent := True;
    edcsosn_id.SetParentComponent(Self);
    edcsosn_id.Name := 'edcsosn_id';
    edcsosn_id.Left := 221;
    edcsosn_id.Top := 1377;
    edcsosn_id.Width := 200;
    edcsosn_id.Height := 21;
    edcsosn_id.Enabled := True;
    edcsosn_id.TabOrder := 50;
    edcsosn_id.Text := 'edcsosn_id';
    edcsosn_id.DataField := 'csosn_id';
    edcsosn_id.DataSource := DataSource;
    lborigem_csosn_id.SetParentComponent(Self);
    lborigem_csosn_id.Name := 'lborigem_csosn_id';
    lborigem_csosn_id.Left := 24;
    lborigem_csosn_id.Top := 1407;
    lborigem_csosn_id.Width := 14;
    lborigem_csosn_id.Height := 13;
    lborigem_csosn_id.Caption := 'origem_csosn_id:';
    lborigem_csosn_id.Transparent := True;
    edorigem_csosn_id.SetParentComponent(Self);
    edorigem_csosn_id.Name := 'edorigem_csosn_id';
    edorigem_csosn_id.Left := 221;
    edorigem_csosn_id.Top := 1404;
    edorigem_csosn_id.Width := 200;
    edorigem_csosn_id.Height := 21;
    edorigem_csosn_id.Enabled := True;
    edorigem_csosn_id.TabOrder := 51;
    edorigem_csosn_id.Text := 'edorigem_csosn_id';
    edorigem_csosn_id.DataField := 'origem_csosn_id';
    edorigem_csosn_id.DataSource := DataSource;
    lbquantidade_selo_ipi.SetParentComponent(Self);
    lbquantidade_selo_ipi.Name := 'lbquantidade_selo_ipi';
    lbquantidade_selo_ipi.Left := 24;
    lbquantidade_selo_ipi.Top := 1434;
    lbquantidade_selo_ipi.Width := 14;
    lbquantidade_selo_ipi.Height := 13;
    lbquantidade_selo_ipi.Caption := 'quantidade_selo_ipi:';
    lbquantidade_selo_ipi.Transparent := True;
    edquantidade_selo_ipi.SetParentComponent(Self);
    edquantidade_selo_ipi.Name := 'edquantidade_selo_ipi';
    edquantidade_selo_ipi.Left := 221;
    edquantidade_selo_ipi.Top := 1431;
    edquantidade_selo_ipi.Width := 200;
    edquantidade_selo_ipi.Height := 21;
    edquantidade_selo_ipi.Enabled := True;
    edquantidade_selo_ipi.TabOrder := 52;
    edquantidade_selo_ipi.Text := 'edquantidade_selo_ipi';
    edquantidade_selo_ipi.DataField := 'quantidade_selo_ipi';
    edquantidade_selo_ipi.DataSource := DataSource;
    lbvalor_base_issqn.SetParentComponent(Self);
    lbvalor_base_issqn.Name := 'lbvalor_base_issqn';
    lbvalor_base_issqn.Left := 24;
    lbvalor_base_issqn.Top := 1461;
    lbvalor_base_issqn.Width := 14;
    lbvalor_base_issqn.Height := 13;
    lbvalor_base_issqn.Caption := 'valor_base_issqn:';
    lbvalor_base_issqn.Transparent := True;
    edvalor_base_issqn.SetParentComponent(Self);
    edvalor_base_issqn.Name := 'edvalor_base_issqn';
    edvalor_base_issqn.Left := 221;
    edvalor_base_issqn.Top := 1458;
    edvalor_base_issqn.Width := 200;
    edvalor_base_issqn.Height := 21;
    edvalor_base_issqn.Enabled := True;
    edvalor_base_issqn.TabOrder := 53;
    edvalor_base_issqn.Text := 'edvalor_base_issqn';
    edvalor_base_issqn.DataField := 'valor_base_issqn';
    edvalor_base_issqn.DataSource := DataSource;
    lbissqn.SetParentComponent(Self);
    lbissqn.Name := 'lbissqn';
    lbissqn.Left := 24;
    lbissqn.Top := 1488;
    lbissqn.Width := 14;
    lbissqn.Height := 13;
    lbissqn.Caption := 'issqn:';
    lbissqn.Transparent := True;
    edissqn.SetParentComponent(Self);
    edissqn.Name := 'edissqn';
    edissqn.Left := 221;
    edissqn.Top := 1485;
    edissqn.Width := 200;
    edissqn.Height := 21;
    edissqn.Enabled := True;
    edissqn.TabOrder := 54;
    edissqn.Text := 'edissqn';
    edissqn.DataField := 'issqn';
    edissqn.DataSource := DataSource;
    lbcodigo_issqn.SetParentComponent(Self);
    lbcodigo_issqn.Name := 'lbcodigo_issqn';
    lbcodigo_issqn.Left := 24;
    lbcodigo_issqn.Top := 1515;
    lbcodigo_issqn.Width := 14;
    lbcodigo_issqn.Height := 13;
    lbcodigo_issqn.Caption := 'codigo_issqn:';
    lbcodigo_issqn.Transparent := True;
    edcodigo_issqn.SetParentComponent(Self);
    edcodigo_issqn.Name := 'edcodigo_issqn';
    edcodigo_issqn.Left := 221;
    edcodigo_issqn.Top := 1512;
    edcodigo_issqn.Width := 200;
    edcodigo_issqn.Height := 21;
    edcodigo_issqn.Enabled := True;
    edcodigo_issqn.TabOrder := 55;
    edcodigo_issqn.Text := 'edcodigo_issqn';
    edcodigo_issqn.DataField := 'codigo_issqn';
    edcodigo_issqn.DataSource := DataSource;
    lbvalor_issqn.SetParentComponent(Self);
    lbvalor_issqn.Name := 'lbvalor_issqn';
    lbvalor_issqn.Left := 24;
    lbvalor_issqn.Top := 1542;
    lbvalor_issqn.Width := 14;
    lbvalor_issqn.Height := 13;
    lbvalor_issqn.Caption := 'valor_issqn:';
    lbvalor_issqn.Transparent := True;
    edvalor_issqn.SetParentComponent(Self);
    edvalor_issqn.Name := 'edvalor_issqn';
    edvalor_issqn.Left := 221;
    edvalor_issqn.Top := 1539;
    edvalor_issqn.Width := 200;
    edvalor_issqn.Height := 21;
    edvalor_issqn.Enabled := True;
    edvalor_issqn.TabOrder := 56;
    edvalor_issqn.Text := 'edvalor_issqn';
    edvalor_issqn.DataField := 'valor_issqn';
    edvalor_issqn.DataSource := DataSource;
    lbvalor_base_pis.SetParentComponent(Self);
    lbvalor_base_pis.Name := 'lbvalor_base_pis';
    lbvalor_base_pis.Left := 24;
    lbvalor_base_pis.Top := 1569;
    lbvalor_base_pis.Width := 14;
    lbvalor_base_pis.Height := 13;
    lbvalor_base_pis.Caption := 'valor_base_pis:';
    lbvalor_base_pis.Transparent := True;
    edvalor_base_pis.SetParentComponent(Self);
    edvalor_base_pis.Name := 'edvalor_base_pis';
    edvalor_base_pis.Left := 221;
    edvalor_base_pis.Top := 1566;
    edvalor_base_pis.Width := 200;
    edvalor_base_pis.Height := 21;
    edvalor_base_pis.Enabled := True;
    edvalor_base_pis.TabOrder := 57;
    edvalor_base_pis.Text := 'edvalor_base_pis';
    edvalor_base_pis.DataField := 'valor_base_pis';
    edvalor_base_pis.DataSource := DataSource;
    lbpis.SetParentComponent(Self);
    lbpis.Name := 'lbpis';
    lbpis.Left := 24;
    lbpis.Top := 1596;
    lbpis.Width := 14;
    lbpis.Height := 13;
    lbpis.Caption := 'pis:';
    lbpis.Transparent := True;
    edpis.SetParentComponent(Self);
    edpis.Name := 'edpis';
    edpis.Left := 221;
    edpis.Top := 1593;
    edpis.Width := 200;
    edpis.Height := 21;
    edpis.Enabled := True;
    edpis.TabOrder := 58;
    edpis.Text := 'edpis';
    edpis.DataField := 'pis';
    edpis.DataSource := DataSource;
    lbvalor_pis.SetParentComponent(Self);
    lbvalor_pis.Name := 'lbvalor_pis';
    lbvalor_pis.Left := 24;
    lbvalor_pis.Top := 1623;
    lbvalor_pis.Width := 14;
    lbvalor_pis.Height := 13;
    lbvalor_pis.Caption := 'valor_pis:';
    lbvalor_pis.Transparent := True;
    edvalor_pis.SetParentComponent(Self);
    edvalor_pis.Name := 'edvalor_pis';
    edvalor_pis.Left := 221;
    edvalor_pis.Top := 1620;
    edvalor_pis.Width := 200;
    edvalor_pis.Height := 21;
    edvalor_pis.Enabled := True;
    edvalor_pis.TabOrder := 59;
    edvalor_pis.Text := 'edvalor_pis';
    edvalor_pis.DataField := 'valor_pis';
    edvalor_pis.DataSource := DataSource;
    lbvalor_base_cofins.SetParentComponent(Self);
    lbvalor_base_cofins.Name := 'lbvalor_base_cofins';
    lbvalor_base_cofins.Left := 24;
    lbvalor_base_cofins.Top := 1650;
    lbvalor_base_cofins.Width := 14;
    lbvalor_base_cofins.Height := 13;
    lbvalor_base_cofins.Caption := 'valor_base_cofins:';
    lbvalor_base_cofins.Transparent := True;
    edvalor_base_cofins.SetParentComponent(Self);
    edvalor_base_cofins.Name := 'edvalor_base_cofins';
    edvalor_base_cofins.Left := 221;
    edvalor_base_cofins.Top := 1647;
    edvalor_base_cofins.Width := 200;
    edvalor_base_cofins.Height := 21;
    edvalor_base_cofins.Enabled := True;
    edvalor_base_cofins.TabOrder := 60;
    edvalor_base_cofins.Text := 'edvalor_base_cofins';
    edvalor_base_cofins.DataField := 'valor_base_cofins';
    edvalor_base_cofins.DataSource := DataSource;
    lbcofins.SetParentComponent(Self);
    lbcofins.Name := 'lbcofins';
    lbcofins.Left := 24;
    lbcofins.Top := 1677;
    lbcofins.Width := 14;
    lbcofins.Height := 13;
    lbcofins.Caption := 'cofins:';
    lbcofins.Transparent := True;
    edcofins.SetParentComponent(Self);
    edcofins.Name := 'edcofins';
    edcofins.Left := 221;
    edcofins.Top := 1674;
    edcofins.Width := 200;
    edcofins.Height := 21;
    edcofins.Enabled := True;
    edcofins.TabOrder := 61;
    edcofins.Text := 'edcofins';
    edcofins.DataField := 'cofins';
    edcofins.DataSource := DataSource;
    lbvalor_cofins.SetParentComponent(Self);
    lbvalor_cofins.Name := 'lbvalor_cofins';
    lbvalor_cofins.Left := 24;
    lbvalor_cofins.Top := 1704;
    lbvalor_cofins.Width := 14;
    lbvalor_cofins.Height := 13;
    lbvalor_cofins.Caption := 'valor_cofins:';
    lbvalor_cofins.Transparent := True;
    edvalor_cofins.SetParentComponent(Self);
    edvalor_cofins.Name := 'edvalor_cofins';
    edvalor_cofins.Left := 221;
    edvalor_cofins.Top := 1701;
    edvalor_cofins.Width := 200;
    edvalor_cofins.Height := 21;
    edvalor_cofins.Enabled := True;
    edvalor_cofins.TabOrder := 62;
    edvalor_cofins.Text := 'edvalor_cofins';
    edvalor_cofins.DataField := 'valor_cofins';
    edvalor_cofins.DataSource := DataSource;
    lbcodigo_bc_piscofins_id.SetParentComponent(Self);
    lbcodigo_bc_piscofins_id.Name := 'lbcodigo_bc_piscofins_id';
    lbcodigo_bc_piscofins_id.Left := 24;
    lbcodigo_bc_piscofins_id.Top := 1731;
    lbcodigo_bc_piscofins_id.Width := 14;
    lbcodigo_bc_piscofins_id.Height := 13;
    lbcodigo_bc_piscofins_id.Caption := 'codigo_bc_piscofins_id:';
    lbcodigo_bc_piscofins_id.Transparent := True;
    edcodigo_bc_piscofins_id.SetParentComponent(Self);
    edcodigo_bc_piscofins_id.Name := 'edcodigo_bc_piscofins_id';
    edcodigo_bc_piscofins_id.Left := 221;
    edcodigo_bc_piscofins_id.Top := 1728;
    edcodigo_bc_piscofins_id.Width := 200;
    edcodigo_bc_piscofins_id.Height := 21;
    edcodigo_bc_piscofins_id.Enabled := True;
    edcodigo_bc_piscofins_id.TabOrder := 63;
    edcodigo_bc_piscofins_id.Text := 'edcodigo_bc_piscofins_id';
    edcodigo_bc_piscofins_id.DataField := 'codigo_bc_piscofins_id';
    edcodigo_bc_piscofins_id.DataSource := DataSource;
    lbcodigo_credito_piscofins_id.SetParentComponent(Self);
    lbcodigo_credito_piscofins_id.Name := 'lbcodigo_credito_piscofins_id';
    lbcodigo_credito_piscofins_id.Left := 24;
    lbcodigo_credito_piscofins_id.Top := 1758;
    lbcodigo_credito_piscofins_id.Width := 14;
    lbcodigo_credito_piscofins_id.Height := 13;
    lbcodigo_credito_piscofins_id.Caption := 'codigo_credito_piscofins_id:';
    lbcodigo_credito_piscofins_id.Transparent := True;
    edcodigo_credito_piscofins_id.SetParentComponent(Self);
    edcodigo_credito_piscofins_id.Name := 'edcodigo_credito_piscofins_id';
    edcodigo_credito_piscofins_id.Left := 221;
    edcodigo_credito_piscofins_id.Top := 1755;
    edcodigo_credito_piscofins_id.Width := 200;
    edcodigo_credito_piscofins_id.Height := 21;
    edcodigo_credito_piscofins_id.Enabled := True;
    edcodigo_credito_piscofins_id.TabOrder := 64;
    edcodigo_credito_piscofins_id.Text := 'edcodigo_credito_piscofins_id';
    edcodigo_credito_piscofins_id.DataField := 'codigo_credito_piscofins_id';
    edcodigo_credito_piscofins_id.DataSource := DataSource;
    lbvalor_base_st_retida.SetParentComponent(Self);
    lbvalor_base_st_retida.Name := 'lbvalor_base_st_retida';
    lbvalor_base_st_retida.Left := 24;
    lbvalor_base_st_retida.Top := 1785;
    lbvalor_base_st_retida.Width := 14;
    lbvalor_base_st_retida.Height := 13;
    lbvalor_base_st_retida.Caption := 'valor_base_st_retida:';
    lbvalor_base_st_retida.Transparent := True;
    edvalor_base_st_retida.SetParentComponent(Self);
    edvalor_base_st_retida.Name := 'edvalor_base_st_retida';
    edvalor_base_st_retida.Left := 221;
    edvalor_base_st_retida.Top := 1782;
    edvalor_base_st_retida.Width := 200;
    edvalor_base_st_retida.Height := 21;
    edvalor_base_st_retida.Enabled := True;
    edvalor_base_st_retida.TabOrder := 65;
    edvalor_base_st_retida.Text := 'edvalor_base_st_retida';
    edvalor_base_st_retida.DataField := 'valor_base_st_retida';
    edvalor_base_st_retida.DataSource := DataSource;
    lbst_retida.SetParentComponent(Self);
    lbst_retida.Name := 'lbst_retida';
    lbst_retida.Left := 24;
    lbst_retida.Top := 1812;
    lbst_retida.Width := 14;
    lbst_retida.Height := 13;
    lbst_retida.Caption := 'st_retida:';
    lbst_retida.Transparent := True;
    edst_retida.SetParentComponent(Self);
    edst_retida.Name := 'edst_retida';
    edst_retida.Left := 221;
    edst_retida.Top := 1809;
    edst_retida.Width := 200;
    edst_retida.Height := 21;
    edst_retida.Enabled := True;
    edst_retida.TabOrder := 66;
    edst_retida.Text := 'edst_retida';
    edst_retida.DataField := 'st_retida';
    edst_retida.DataSource := DataSource;
    lbvalor_st_retida.SetParentComponent(Self);
    lbvalor_st_retida.Name := 'lbvalor_st_retida';
    lbvalor_st_retida.Left := 24;
    lbvalor_st_retida.Top := 1839;
    lbvalor_st_retida.Width := 14;
    lbvalor_st_retida.Height := 13;
    lbvalor_st_retida.Caption := 'valor_st_retida:';
    lbvalor_st_retida.Transparent := True;
    edvalor_st_retida.SetParentComponent(Self);
    edvalor_st_retida.Name := 'edvalor_st_retida';
    edvalor_st_retida.Left := 221;
    edvalor_st_retida.Top := 1836;
    edvalor_st_retida.Width := 200;
    edvalor_st_retida.Height := 21;
    edvalor_st_retida.Enabled := True;
    edvalor_st_retida.TabOrder := 67;
    edvalor_st_retida.Text := 'edvalor_st_retida';
    edvalor_st_retida.DataField := 'valor_st_retida';
    edvalor_st_retida.DataSource := DataSource;
    lbvalor_pis_retido.SetParentComponent(Self);
    lbvalor_pis_retido.Name := 'lbvalor_pis_retido';
    lbvalor_pis_retido.Left := 24;
    lbvalor_pis_retido.Top := 1866;
    lbvalor_pis_retido.Width := 14;
    lbvalor_pis_retido.Height := 13;
    lbvalor_pis_retido.Caption := 'valor_pis_retido:';
    lbvalor_pis_retido.Transparent := True;
    edvalor_pis_retido.SetParentComponent(Self);
    edvalor_pis_retido.Name := 'edvalor_pis_retido';
    edvalor_pis_retido.Left := 221;
    edvalor_pis_retido.Top := 1863;
    edvalor_pis_retido.Width := 200;
    edvalor_pis_retido.Height := 21;
    edvalor_pis_retido.Enabled := True;
    edvalor_pis_retido.TabOrder := 68;
    edvalor_pis_retido.Text := 'edvalor_pis_retido';
    edvalor_pis_retido.DataField := 'valor_pis_retido';
    edvalor_pis_retido.DataSource := DataSource;
    lbvalor_cofins_retido.SetParentComponent(Self);
    lbvalor_cofins_retido.Name := 'lbvalor_cofins_retido';
    lbvalor_cofins_retido.Left := 24;
    lbvalor_cofins_retido.Top := 1893;
    lbvalor_cofins_retido.Width := 14;
    lbvalor_cofins_retido.Height := 13;
    lbvalor_cofins_retido.Caption := 'valor_cofins_retido:';
    lbvalor_cofins_retido.Transparent := True;
    edvalor_cofins_retido.SetParentComponent(Self);
    edvalor_cofins_retido.Name := 'edvalor_cofins_retido';
    edvalor_cofins_retido.Left := 221;
    edvalor_cofins_retido.Top := 1890;
    edvalor_cofins_retido.Width := 200;
    edvalor_cofins_retido.Height := 21;
    edvalor_cofins_retido.Enabled := True;
    edvalor_cofins_retido.TabOrder := 69;
    edvalor_cofins_retido.Text := 'edvalor_cofins_retido';
    edvalor_cofins_retido.DataField := 'valor_cofins_retido';
    edvalor_cofins_retido.DataSource := DataSource;
    lbvalor_desconto_nota.SetParentComponent(Self);
    lbvalor_desconto_nota.Name := 'lbvalor_desconto_nota';
    lbvalor_desconto_nota.Left := 24;
    lbvalor_desconto_nota.Top := 1920;
    lbvalor_desconto_nota.Width := 14;
    lbvalor_desconto_nota.Height := 13;
    lbvalor_desconto_nota.Caption := 'valor_desconto_nota:';
    lbvalor_desconto_nota.Transparent := True;
    edvalor_desconto_nota.SetParentComponent(Self);
    edvalor_desconto_nota.Name := 'edvalor_desconto_nota';
    edvalor_desconto_nota.Left := 221;
    edvalor_desconto_nota.Top := 1917;
    edvalor_desconto_nota.Width := 200;
    edvalor_desconto_nota.Height := 21;
    edvalor_desconto_nota.Enabled := True;
    edvalor_desconto_nota.TabOrder := 70;
    edvalor_desconto_nota.Text := 'edvalor_desconto_nota';
    edvalor_desconto_nota.DataField := 'valor_desconto_nota';
    edvalor_desconto_nota.DataSource := DataSource;
    lbvalor_total_liquido.SetParentComponent(Self);
    lbvalor_total_liquido.Name := 'lbvalor_total_liquido';
    lbvalor_total_liquido.Left := 24;
    lbvalor_total_liquido.Top := 1947;
    lbvalor_total_liquido.Width := 14;
    lbvalor_total_liquido.Height := 13;
    lbvalor_total_liquido.Caption := 'valor_total_liquido:';
    lbvalor_total_liquido.Transparent := True;
    edvalor_total_liquido.SetParentComponent(Self);
    edvalor_total_liquido.Name := 'edvalor_total_liquido';
    edvalor_total_liquido.Left := 221;
    edvalor_total_liquido.Top := 1944;
    edvalor_total_liquido.Width := 200;
    edvalor_total_liquido.Height := 21;
    edvalor_total_liquido.Enabled := True;
    edvalor_total_liquido.TabOrder := 71;
    edvalor_total_liquido.Text := 'edvalor_total_liquido';
    edvalor_total_liquido.DataField := 'valor_total_liquido';
    edvalor_total_liquido.DataSource := DataSource;
    lbvalor_total_impostos.SetParentComponent(Self);
    lbvalor_total_impostos.Name := 'lbvalor_total_impostos';
    lbvalor_total_impostos.Left := 24;
    lbvalor_total_impostos.Top := 1974;
    lbvalor_total_impostos.Width := 14;
    lbvalor_total_impostos.Height := 13;
    lbvalor_total_impostos.Caption := 'valor_total_impostos:';
    lbvalor_total_impostos.Transparent := True;
    edvalor_total_impostos.SetParentComponent(Self);
    edvalor_total_impostos.Name := 'edvalor_total_impostos';
    edvalor_total_impostos.Left := 221;
    edvalor_total_impostos.Top := 1971;
    edvalor_total_impostos.Width := 200;
    edvalor_total_impostos.Height := 21;
    edvalor_total_impostos.Enabled := True;
    edvalor_total_impostos.TabOrder := 72;
    edvalor_total_impostos.Text := 'edvalor_total_impostos';
    edvalor_total_impostos.DataField := 'valor_total_impostos';
    edvalor_total_impostos.DataSource := DataSource;
    lbvalor_frete_por_fora.SetParentComponent(Self);
    lbvalor_frete_por_fora.Name := 'lbvalor_frete_por_fora';
    lbvalor_frete_por_fora.Left := 24;
    lbvalor_frete_por_fora.Top := 2001;
    lbvalor_frete_por_fora.Width := 14;
    lbvalor_frete_por_fora.Height := 13;
    lbvalor_frete_por_fora.Caption := 'valor_frete_por_fora:';
    lbvalor_frete_por_fora.Transparent := True;
    edvalor_frete_por_fora.SetParentComponent(Self);
    edvalor_frete_por_fora.Name := 'edvalor_frete_por_fora';
    edvalor_frete_por_fora.Left := 221;
    edvalor_frete_por_fora.Top := 1998;
    edvalor_frete_por_fora.Width := 200;
    edvalor_frete_por_fora.Height := 21;
    edvalor_frete_por_fora.Enabled := True;
    edvalor_frete_por_fora.TabOrder := 73;
    edvalor_frete_por_fora.Text := 'edvalor_frete_por_fora';
    edvalor_frete_por_fora.DataField := 'valor_frete_por_fora';
    edvalor_frete_por_fora.DataSource := DataSource;
    lbvalor_outras_despesas.SetParentComponent(Self);
    lbvalor_outras_despesas.Name := 'lbvalor_outras_despesas';
    lbvalor_outras_despesas.Left := 24;
    lbvalor_outras_despesas.Top := 2028;
    lbvalor_outras_despesas.Width := 14;
    lbvalor_outras_despesas.Height := 13;
    lbvalor_outras_despesas.Caption := 'valor_outras_despesas:';
    lbvalor_outras_despesas.Transparent := True;
    edvalor_outras_despesas.SetParentComponent(Self);
    edvalor_outras_despesas.Name := 'edvalor_outras_despesas';
    edvalor_outras_despesas.Left := 221;
    edvalor_outras_despesas.Top := 2025;
    edvalor_outras_despesas.Width := 200;
    edvalor_outras_despesas.Height := 21;
    edvalor_outras_despesas.Enabled := True;
    edvalor_outras_despesas.TabOrder := 74;
    edvalor_outras_despesas.Text := 'edvalor_outras_despesas';
    edvalor_outras_despesas.DataField := 'valor_outras_despesas';
    edvalor_outras_despesas.DataSource := DataSource;
    lbvalor_preco_custo.SetParentComponent(Self);
    lbvalor_preco_custo.Name := 'lbvalor_preco_custo';
    lbvalor_preco_custo.Left := 24;
    lbvalor_preco_custo.Top := 2055;
    lbvalor_preco_custo.Width := 14;
    lbvalor_preco_custo.Height := 13;
    lbvalor_preco_custo.Caption := 'valor_preco_custo:';
    lbvalor_preco_custo.Transparent := True;
    edvalor_preco_custo.SetParentComponent(Self);
    edvalor_preco_custo.Name := 'edvalor_preco_custo';
    edvalor_preco_custo.Left := 221;
    edvalor_preco_custo.Top := 2052;
    edvalor_preco_custo.Width := 200;
    edvalor_preco_custo.Height := 21;
    edvalor_preco_custo.Enabled := True;
    edvalor_preco_custo.TabOrder := 75;
    edvalor_preco_custo.Text := 'edvalor_preco_custo';
    edvalor_preco_custo.DataField := 'valor_preco_custo';
    edvalor_preco_custo.DataSource := DataSource;
    lbvalor_preco_venda.SetParentComponent(Self);
    lbvalor_preco_venda.Name := 'lbvalor_preco_venda';
    lbvalor_preco_venda.Left := 24;
    lbvalor_preco_venda.Top := 2082;
    lbvalor_preco_venda.Width := 14;
    lbvalor_preco_venda.Height := 13;
    lbvalor_preco_venda.Caption := 'valor_preco_venda:';
    lbvalor_preco_venda.Transparent := True;
    edvalor_preco_venda.SetParentComponent(Self);
    edvalor_preco_venda.Name := 'edvalor_preco_venda';
    edvalor_preco_venda.Left := 221;
    edvalor_preco_venda.Top := 2079;
    edvalor_preco_venda.Width := 200;
    edvalor_preco_venda.Height := 21;
    edvalor_preco_venda.Enabled := True;
    edvalor_preco_venda.TabOrder := 76;
    edvalor_preco_venda.Text := 'edvalor_preco_venda';
    edvalor_preco_venda.DataField := 'valor_preco_venda';
    edvalor_preco_venda.DataSource := DataSource;
    lbvalor_icms_desonerado.SetParentComponent(Self);
    lbvalor_icms_desonerado.Name := 'lbvalor_icms_desonerado';
    lbvalor_icms_desonerado.Left := 24;
    lbvalor_icms_desonerado.Top := 2109;
    lbvalor_icms_desonerado.Width := 14;
    lbvalor_icms_desonerado.Height := 13;
    lbvalor_icms_desonerado.Caption := 'valor_icms_desonerado:';
    lbvalor_icms_desonerado.Transparent := True;
    edvalor_icms_desonerado.SetParentComponent(Self);
    edvalor_icms_desonerado.Name := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.Left := 221;
    edvalor_icms_desonerado.Top := 2106;
    edvalor_icms_desonerado.Width := 200;
    edvalor_icms_desonerado.Height := 21;
    edvalor_icms_desonerado.Enabled := True;
    edvalor_icms_desonerado.TabOrder := 77;
    edvalor_icms_desonerado.Text := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.DataField := 'valor_icms_desonerado';
    edvalor_icms_desonerado.DataSource := DataSource;
    lbdesoneracao_icms_id.SetParentComponent(Self);
    lbdesoneracao_icms_id.Name := 'lbdesoneracao_icms_id';
    lbdesoneracao_icms_id.Left := 24;
    lbdesoneracao_icms_id.Top := 2136;
    lbdesoneracao_icms_id.Width := 14;
    lbdesoneracao_icms_id.Height := 13;
    lbdesoneracao_icms_id.Caption := 'desoneracao_icms_id:';
    lbdesoneracao_icms_id.Transparent := True;
    eddesoneracao_icms_id.SetParentComponent(Self);
    eddesoneracao_icms_id.Name := 'eddesoneracao_icms_id';
    eddesoneracao_icms_id.Left := 221;
    eddesoneracao_icms_id.Top := 2133;
    eddesoneracao_icms_id.Width := 200;
    eddesoneracao_icms_id.Height := 21;
    eddesoneracao_icms_id.Enabled := True;
    eddesoneracao_icms_id.TabOrder := 78;
    eddesoneracao_icms_id.Text := 'eddesoneracao_icms_id';
    eddesoneracao_icms_id.DataField := 'desoneracao_icms_id';
    eddesoneracao_icms_id.DataSource := DataSource;
    lbvalor_icms_proprio_st.SetParentComponent(Self);
    lbvalor_icms_proprio_st.Name := 'lbvalor_icms_proprio_st';
    lbvalor_icms_proprio_st.Left := 24;
    lbvalor_icms_proprio_st.Top := 2163;
    lbvalor_icms_proprio_st.Width := 14;
    lbvalor_icms_proprio_st.Height := 13;
    lbvalor_icms_proprio_st.Caption := 'valor_icms_proprio_st:';
    lbvalor_icms_proprio_st.Transparent := True;
    edvalor_icms_proprio_st.SetParentComponent(Self);
    edvalor_icms_proprio_st.Name := 'edvalor_icms_proprio_st';
    edvalor_icms_proprio_st.Left := 221;
    edvalor_icms_proprio_st.Top := 2160;
    edvalor_icms_proprio_st.Width := 200;
    edvalor_icms_proprio_st.Height := 21;
    edvalor_icms_proprio_st.Enabled := True;
    edvalor_icms_proprio_st.TabOrder := 79;
    edvalor_icms_proprio_st.Text := 'edvalor_icms_proprio_st';
    edvalor_icms_proprio_st.DataField := 'valor_icms_proprio_st';
    edvalor_icms_proprio_st.DataSource := DataSource;
    lbvalor_icms_original.SetParentComponent(Self);
    lbvalor_icms_original.Name := 'lbvalor_icms_original';
    lbvalor_icms_original.Left := 24;
    lbvalor_icms_original.Top := 2190;
    lbvalor_icms_original.Width := 14;
    lbvalor_icms_original.Height := 13;
    lbvalor_icms_original.Caption := 'valor_icms_original:';
    lbvalor_icms_original.Transparent := True;
    edvalor_icms_original.SetParentComponent(Self);
    edvalor_icms_original.Name := 'edvalor_icms_original';
    edvalor_icms_original.Left := 221;
    edvalor_icms_original.Top := 2187;
    edvalor_icms_original.Width := 200;
    edvalor_icms_original.Height := 21;
    edvalor_icms_original.Enabled := True;
    edvalor_icms_original.TabOrder := 80;
    edvalor_icms_original.Text := 'edvalor_icms_original';
    edvalor_icms_original.DataField := 'valor_icms_original';
    edvalor_icms_original.DataSource := DataSource;
    lbplano_contas_contabil_id.SetParentComponent(Self);
    lbplano_contas_contabil_id.Name := 'lbplano_contas_contabil_id';
    lbplano_contas_contabil_id.Left := 24;
    lbplano_contas_contabil_id.Top := 2217;
    lbplano_contas_contabil_id.Width := 14;
    lbplano_contas_contabil_id.Height := 13;
    lbplano_contas_contabil_id.Caption := 'plano_contas_contabil_id:';
    lbplano_contas_contabil_id.Transparent := True;
    edplano_contas_contabil_id.SetParentComponent(Self);
    edplano_contas_contabil_id.Name := 'edplano_contas_contabil_id';
    edplano_contas_contabil_id.Left := 221;
    edplano_contas_contabil_id.Top := 2214;
    edplano_contas_contabil_id.Width := 200;
    edplano_contas_contabil_id.Height := 21;
    edplano_contas_contabil_id.Enabled := True;
    edplano_contas_contabil_id.TabOrder := 81;
    edplano_contas_contabil_id.Text := 'edplano_contas_contabil_id';
    edplano_contas_contabil_id.DataField := 'plano_contas_contabil_id';
    edplano_contas_contabil_id.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 2244;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 2241;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 82;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 2271;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 2268;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 83;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 2298;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 2295;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 84;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 2325;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 2322;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 85;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 2352;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 2349;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 86;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Itens_EntradaDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Itens_EntradaDataset.SetParentComponent(Self);
    Itens_EntradaDataset.Name := 'Itens_EntradaDataset';
    Itens_EntradaDataset.AfterApplyUpdates := Itens_EntradaDatasetAfterApplyUpdates;
    Itens_EntradaDataset.EntitySetName := 'Itens_Entrada';
    Itens_EntradaDataset.Connection := DMConnection.ApiConnection;
    Itens_EntradaDataset.Left := 176;
    Itens_EntradaDataset.Top := 8;
    Itens_EntradaDatasetid.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetid.Name := 'Itens_EntradaDatasetid';
    Itens_EntradaDatasetid.FieldName := 'id';
    Itens_EntradaDatasetid.Required := True;
    Itens_EntradaDatasetaliado_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetaliado_id.Name := 'Itens_EntradaDatasetaliado_id';
    Itens_EntradaDatasetaliado_id.FieldName := 'aliado_id';
    Itens_EntradaDatasetaliado_id.Required := True;
    Itens_EntradaDatasetdata_base_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdata_base_id.Name := 'Itens_EntradaDatasetdata_base_id';
    Itens_EntradaDatasetdata_base_id.FieldName := 'data_base_id';
    Itens_EntradaDatasetdata_base_id.Required := True;
    Itens_EntradaDatasetcompra_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcompra_id.Name := 'Itens_EntradaDatasetcompra_id';
    Itens_EntradaDatasetcompra_id.FieldName := 'compra_id';
    Itens_EntradaDatasetcompra_id.Required := True;
    Itens_EntradaDatasetitem.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetitem.Name := 'Itens_EntradaDatasetitem';
    Itens_EntradaDatasetitem.FieldName := 'item';
    Itens_EntradaDatasetitem.Required := False;
    Itens_EntradaDatasetproduto_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetproduto_id.Name := 'Itens_EntradaDatasetproduto_id';
    Itens_EntradaDatasetproduto_id.FieldName := 'produto_id';
    Itens_EntradaDatasetproduto_id.Required := True;
    Itens_EntradaDatasetgrade_produto_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetgrade_produto_id.Name := 'Itens_EntradaDatasetgrade_produto_id';
    Itens_EntradaDatasetgrade_produto_id.FieldName := 'grade_produto_id';
    Itens_EntradaDatasetgrade_produto_id.Required := False;
    Itens_EntradaDatasetproduto_nome.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetproduto_nome.Name := 'Itens_EntradaDatasetproduto_nome';
    Itens_EntradaDatasetproduto_nome.FieldName := 'produto_nome';
    Itens_EntradaDatasetproduto_nome.Required := False;
    Itens_EntradaDatasetproduto_nome.Size := 255;
    Itens_EntradaDatasetmovimenta_estoque.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetmovimenta_estoque.Name := 'Itens_EntradaDatasetmovimenta_estoque';
    Itens_EntradaDatasetmovimenta_estoque.FieldName := 'movimenta_estoque';
    Itens_EntradaDatasetmovimenta_estoque.Required := True;
    Itens_EntradaDatasetestoque_inicial.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetestoque_inicial.Name := 'Itens_EntradaDatasetestoque_inicial';
    Itens_EntradaDatasetestoque_inicial.FieldName := 'estoque_inicial';
    Itens_EntradaDatasetestoque_inicial.Required := False;
    Itens_EntradaDatasetestoque_final.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetestoque_final.Name := 'Itens_EntradaDatasetestoque_final';
    Itens_EntradaDatasetestoque_final.FieldName := 'estoque_final';
    Itens_EntradaDatasetestoque_final.Required := False;
    Itens_EntradaDatasetcfop_cfop.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcfop_cfop.Name := 'Itens_EntradaDatasetcfop_cfop';
    Itens_EntradaDatasetcfop_cfop.FieldName := 'cfop_cfop';
    Itens_EntradaDatasetcfop_cfop.Required := True;
    Itens_EntradaDatasetcfop_cfop.Size := 255;
    Itens_EntradaDatasetunidade_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetunidade_id.Name := 'Itens_EntradaDatasetunidade_id';
    Itens_EntradaDatasetunidade_id.FieldName := 'unidade_id';
    Itens_EntradaDatasetunidade_id.Required := True;
    Itens_EntradaDatasetquantidade.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetquantidade.Name := 'Itens_EntradaDatasetquantidade';
    Itens_EntradaDatasetquantidade.FieldName := 'quantidade';
    Itens_EntradaDatasetquantidade.Required := True;
    Itens_EntradaDatasetvalor_unitario.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_unitario.Name := 'Itens_EntradaDatasetvalor_unitario';
    Itens_EntradaDatasetvalor_unitario.FieldName := 'valor_unitario';
    Itens_EntradaDatasetvalor_unitario.Required := True;
    Itens_EntradaDatasetdesconto.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdesconto.Name := 'Itens_EntradaDatasetdesconto';
    Itens_EntradaDatasetdesconto.FieldName := 'desconto';
    Itens_EntradaDatasetdesconto.Required := False;
    Itens_EntradaDatasetvalor_desconto.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_desconto.Name := 'Itens_EntradaDatasetvalor_desconto';
    Itens_EntradaDatasetvalor_desconto.FieldName := 'valor_desconto';
    Itens_EntradaDatasetvalor_desconto.Required := False;
    Itens_EntradaDatasetvalor_total.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_total.Name := 'Itens_EntradaDatasetvalor_total';
    Itens_EntradaDatasetvalor_total.FieldName := 'valor_total';
    Itens_EntradaDatasetvalor_total.Required := True;
    Itens_EntradaDatasetvalor_base_icms.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_icms.Name := 'Itens_EntradaDatasetvalor_base_icms';
    Itens_EntradaDatasetvalor_base_icms.FieldName := 'valor_base_icms';
    Itens_EntradaDatasetvalor_base_icms.Required := False;
    Itens_EntradaDataseticms.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDataseticms.Name := 'Itens_EntradaDataseticms';
    Itens_EntradaDataseticms.FieldName := 'icms';
    Itens_EntradaDataseticms.Required := True;
    Itens_EntradaDatasetvalor_icms.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms.Name := 'Itens_EntradaDatasetvalor_icms';
    Itens_EntradaDatasetvalor_icms.FieldName := 'valor_icms';
    Itens_EntradaDatasetvalor_icms.Required := False;
    Itens_EntradaDataseticms_dif.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDataseticms_dif.Name := 'Itens_EntradaDataseticms_dif';
    Itens_EntradaDataseticms_dif.FieldName := 'icms_dif';
    Itens_EntradaDataseticms_dif.Required := False;
    Itens_EntradaDatasetvalor_icms_dif.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_dif.Name := 'Itens_EntradaDatasetvalor_icms_dif';
    Itens_EntradaDatasetvalor_icms_dif.FieldName := 'valor_icms_dif';
    Itens_EntradaDatasetvalor_icms_dif.Required := False;
    Itens_EntradaDatasetvalor_base_st.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_st.Name := 'Itens_EntradaDatasetvalor_base_st';
    Itens_EntradaDatasetvalor_base_st.FieldName := 'valor_base_st';
    Itens_EntradaDatasetvalor_base_st.Required := False;
    Itens_EntradaDatasetst.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetst.Name := 'Itens_EntradaDatasetst';
    Itens_EntradaDatasetst.FieldName := 'st';
    Itens_EntradaDatasetst.Required := False;
    Itens_EntradaDatasetvalor_st.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_st.Name := 'Itens_EntradaDatasetvalor_st';
    Itens_EntradaDatasetvalor_st.FieldName := 'valor_st';
    Itens_EntradaDatasetvalor_st.Required := False;
    Itens_EntradaDataseticms_red.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDataseticms_red.Name := 'Itens_EntradaDataseticms_red';
    Itens_EntradaDataseticms_red.FieldName := 'icms_red';
    Itens_EntradaDataseticms_red.Required := False;
    Itens_EntradaDatasetvalor_icms_red.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_red.Name := 'Itens_EntradaDatasetvalor_icms_red';
    Itens_EntradaDatasetvalor_icms_red.FieldName := 'valor_icms_red';
    Itens_EntradaDatasetvalor_icms_red.Required := False;
    Itens_EntradaDatasetvalor_base_ipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_ipi.Name := 'Itens_EntradaDatasetvalor_base_ipi';
    Itens_EntradaDatasetvalor_base_ipi.FieldName := 'valor_base_ipi';
    Itens_EntradaDatasetvalor_base_ipi.Required := False;
    Itens_EntradaDatasetipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetipi.Name := 'Itens_EntradaDatasetipi';
    Itens_EntradaDatasetipi.FieldName := 'ipi';
    Itens_EntradaDatasetipi.Required := False;
    Itens_EntradaDatasetvalor_ipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_ipi.Name := 'Itens_EntradaDatasetvalor_ipi';
    Itens_EntradaDatasetvalor_ipi.FieldName := 'valor_ipi';
    Itens_EntradaDatasetvalor_ipi.Required := False;
    Itens_EntradaDatasetvalor_custo_unitario.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_custo_unitario.Name := 'Itens_EntradaDatasetvalor_custo_unitario';
    Itens_EntradaDatasetvalor_custo_unitario.FieldName := 'valor_custo_unitario';
    Itens_EntradaDatasetvalor_custo_unitario.Required := False;
    Itens_EntradaDatasetlote_fabricacao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetlote_fabricacao.Name := 'Itens_EntradaDatasetlote_fabricacao';
    Itens_EntradaDatasetlote_fabricacao.FieldName := 'lote_fabricacao';
    Itens_EntradaDatasetlote_fabricacao.Required := False;
    Itens_EntradaDatasetlote_fabricacao.Size := 255;
    Itens_EntradaDatasetdata_fabricacao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdata_fabricacao.Name := 'Itens_EntradaDatasetdata_fabricacao';
    Itens_EntradaDatasetdata_fabricacao.FieldName := 'data_fabricacao';
    Itens_EntradaDatasetdata_fabricacao.Required := False;
    Itens_EntradaDatasetvalidade.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalidade.Name := 'Itens_EntradaDatasetvalidade';
    Itens_EntradaDatasetvalidade.FieldName := 'validade';
    Itens_EntradaDatasetvalidade.Required := False;
    Itens_EntradaDatasetdias_validade.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdias_validade.Name := 'Itens_EntradaDatasetdias_validade';
    Itens_EntradaDatasetdias_validade.FieldName := 'dias_validade';
    Itens_EntradaDatasetdias_validade.Required := False;
    Itens_EntradaDatasetvalor_frete.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_frete.Name := 'Itens_EntradaDatasetvalor_frete';
    Itens_EntradaDatasetvalor_frete.FieldName := 'valor_frete';
    Itens_EntradaDatasetvalor_frete.Required := False;
    Itens_EntradaDatasetvalor_despensa_acessoria.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_despensa_acessoria.Name := 'Itens_EntradaDatasetvalor_despensa_acessoria';
    Itens_EntradaDatasetvalor_despensa_acessoria.FieldName := 'valor_despensa_acessoria';
    Itens_EntradaDatasetvalor_despensa_acessoria.Required := False;
    Itens_EntradaDatasetvalor_seguro.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_seguro.Name := 'Itens_EntradaDatasetvalor_seguro';
    Itens_EntradaDatasetvalor_seguro.FieldName := 'valor_seguro';
    Itens_EntradaDatasetvalor_seguro.Required := False;
    Itens_EntradaDatasetvalor_outras.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_outras.Name := 'Itens_EntradaDatasetvalor_outras';
    Itens_EntradaDatasetvalor_outras.FieldName := 'valor_outras';
    Itens_EntradaDatasetvalor_outras.Required := False;
    Itens_EntradaDatasetcst_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_id.Name := 'Itens_EntradaDatasetcst_id';
    Itens_EntradaDatasetcst_id.FieldName := 'cst_id';
    Itens_EntradaDatasetcst_id.Required := False;
    Itens_EntradaDatasetcst_id.Size := 255;
    Itens_EntradaDatasetcst_ipi_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_ipi_id.Name := 'Itens_EntradaDatasetcst_ipi_id';
    Itens_EntradaDatasetcst_ipi_id.FieldName := 'cst_ipi_id';
    Itens_EntradaDatasetcst_ipi_id.Required := False;
    Itens_EntradaDatasetcst_ipi_id.Size := 255;
    Itens_EntradaDatasetcst_pis_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_pis_id.Name := 'Itens_EntradaDatasetcst_pis_id';
    Itens_EntradaDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Itens_EntradaDatasetcst_pis_id.Required := False;
    Itens_EntradaDatasetcst_pis_id.Size := 255;
    Itens_EntradaDatasetcst_cofins_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_cofins_id.Name := 'Itens_EntradaDatasetcst_cofins_id';
    Itens_EntradaDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Itens_EntradaDatasetcst_cofins_id.Required := False;
    Itens_EntradaDatasetcst_cofins_id.Size := 255;
    Itens_EntradaDatasetcsosn_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcsosn_id.Name := 'Itens_EntradaDatasetcsosn_id';
    Itens_EntradaDatasetcsosn_id.FieldName := 'csosn_id';
    Itens_EntradaDatasetcsosn_id.Required := False;
    Itens_EntradaDatasetcsosn_id.Size := 255;
    Itens_EntradaDatasetorigem_csosn_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetorigem_csosn_id.Name := 'Itens_EntradaDatasetorigem_csosn_id';
    Itens_EntradaDatasetorigem_csosn_id.FieldName := 'origem_csosn_id';
    Itens_EntradaDatasetorigem_csosn_id.Required := True;
    Itens_EntradaDatasetquantidade_selo_ipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetquantidade_selo_ipi.Name := 'Itens_EntradaDatasetquantidade_selo_ipi';
    Itens_EntradaDatasetquantidade_selo_ipi.FieldName := 'quantidade_selo_ipi';
    Itens_EntradaDatasetquantidade_selo_ipi.Required := False;
    Itens_EntradaDatasetvalor_base_issqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_issqn.Name := 'Itens_EntradaDatasetvalor_base_issqn';
    Itens_EntradaDatasetvalor_base_issqn.FieldName := 'valor_base_issqn';
    Itens_EntradaDatasetvalor_base_issqn.Required := False;
    Itens_EntradaDatasetissqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetissqn.Name := 'Itens_EntradaDatasetissqn';
    Itens_EntradaDatasetissqn.FieldName := 'issqn';
    Itens_EntradaDatasetissqn.Required := False;
    Itens_EntradaDatasetcodigo_issqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_issqn.Name := 'Itens_EntradaDatasetcodigo_issqn';
    Itens_EntradaDatasetcodigo_issqn.FieldName := 'codigo_issqn';
    Itens_EntradaDatasetcodigo_issqn.Required := False;
    Itens_EntradaDatasetcodigo_issqn.Size := 255;
    Itens_EntradaDatasetvalor_issqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_issqn.Name := 'Itens_EntradaDatasetvalor_issqn';
    Itens_EntradaDatasetvalor_issqn.FieldName := 'valor_issqn';
    Itens_EntradaDatasetvalor_issqn.Required := False;
    Itens_EntradaDatasetvalor_base_pis.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_pis.Name := 'Itens_EntradaDatasetvalor_base_pis';
    Itens_EntradaDatasetvalor_base_pis.FieldName := 'valor_base_pis';
    Itens_EntradaDatasetvalor_base_pis.Required := False;
    Itens_EntradaDatasetpis.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetpis.Name := 'Itens_EntradaDatasetpis';
    Itens_EntradaDatasetpis.FieldName := 'pis';
    Itens_EntradaDatasetpis.Required := False;
    Itens_EntradaDatasetvalor_pis.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_pis.Name := 'Itens_EntradaDatasetvalor_pis';
    Itens_EntradaDatasetvalor_pis.FieldName := 'valor_pis';
    Itens_EntradaDatasetvalor_pis.Required := False;
    Itens_EntradaDatasetvalor_base_cofins.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_cofins.Name := 'Itens_EntradaDatasetvalor_base_cofins';
    Itens_EntradaDatasetvalor_base_cofins.FieldName := 'valor_base_cofins';
    Itens_EntradaDatasetvalor_base_cofins.Required := False;
    Itens_EntradaDatasetcofins.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcofins.Name := 'Itens_EntradaDatasetcofins';
    Itens_EntradaDatasetcofins.FieldName := 'cofins';
    Itens_EntradaDatasetcofins.Required := False;
    Itens_EntradaDatasetvalor_cofins.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_cofins.Name := 'Itens_EntradaDatasetvalor_cofins';
    Itens_EntradaDatasetvalor_cofins.FieldName := 'valor_cofins';
    Itens_EntradaDatasetvalor_cofins.Required := False;
    Itens_EntradaDatasetcodigo_bc_piscofins_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_bc_piscofins_id.Name := 'Itens_EntradaDatasetcodigo_bc_piscofins_id';
    Itens_EntradaDatasetcodigo_bc_piscofins_id.FieldName := 'codigo_bc_piscofins_id';
    Itens_EntradaDatasetcodigo_bc_piscofins_id.Required := False;
    Itens_EntradaDatasetcodigo_credito_piscofins_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_credito_piscofins_id.Name := 'Itens_EntradaDatasetcodigo_credito_piscofins_id';
    Itens_EntradaDatasetcodigo_credito_piscofins_id.FieldName := 'codigo_credito_piscofins_id';
    Itens_EntradaDatasetcodigo_credito_piscofins_id.Required := False;
    Itens_EntradaDatasetvalor_base_st_retida.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_st_retida.Name := 'Itens_EntradaDatasetvalor_base_st_retida';
    Itens_EntradaDatasetvalor_base_st_retida.FieldName := 'valor_base_st_retida';
    Itens_EntradaDatasetvalor_base_st_retida.Required := False;
    Itens_EntradaDatasetst_retida.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetst_retida.Name := 'Itens_EntradaDatasetst_retida';
    Itens_EntradaDatasetst_retida.FieldName := 'st_retida';
    Itens_EntradaDatasetst_retida.Required := False;
    Itens_EntradaDatasetvalor_st_retida.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_st_retida.Name := 'Itens_EntradaDatasetvalor_st_retida';
    Itens_EntradaDatasetvalor_st_retida.FieldName := 'valor_st_retida';
    Itens_EntradaDatasetvalor_st_retida.Required := False;
    Itens_EntradaDatasetvalor_pis_retido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_pis_retido.Name := 'Itens_EntradaDatasetvalor_pis_retido';
    Itens_EntradaDatasetvalor_pis_retido.FieldName := 'valor_pis_retido';
    Itens_EntradaDatasetvalor_pis_retido.Required := False;
    Itens_EntradaDatasetvalor_cofins_retido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_cofins_retido.Name := 'Itens_EntradaDatasetvalor_cofins_retido';
    Itens_EntradaDatasetvalor_cofins_retido.FieldName := 'valor_cofins_retido';
    Itens_EntradaDatasetvalor_cofins_retido.Required := False;
    Itens_EntradaDatasetvalor_desconto_nota.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_desconto_nota.Name := 'Itens_EntradaDatasetvalor_desconto_nota';
    Itens_EntradaDatasetvalor_desconto_nota.FieldName := 'valor_desconto_nota';
    Itens_EntradaDatasetvalor_desconto_nota.Required := False;
    Itens_EntradaDatasetvalor_total_liquido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_total_liquido.Name := 'Itens_EntradaDatasetvalor_total_liquido';
    Itens_EntradaDatasetvalor_total_liquido.FieldName := 'valor_total_liquido';
    Itens_EntradaDatasetvalor_total_liquido.Required := False;
    Itens_EntradaDatasetvalor_total_impostos.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_total_impostos.Name := 'Itens_EntradaDatasetvalor_total_impostos';
    Itens_EntradaDatasetvalor_total_impostos.FieldName := 'valor_total_impostos';
    Itens_EntradaDatasetvalor_total_impostos.Required := False;
    Itens_EntradaDatasetvalor_frete_por_fora.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_frete_por_fora.Name := 'Itens_EntradaDatasetvalor_frete_por_fora';
    Itens_EntradaDatasetvalor_frete_por_fora.FieldName := 'valor_frete_por_fora';
    Itens_EntradaDatasetvalor_frete_por_fora.Required := False;
    Itens_EntradaDatasetvalor_outras_despesas.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_outras_despesas.Name := 'Itens_EntradaDatasetvalor_outras_despesas';
    Itens_EntradaDatasetvalor_outras_despesas.FieldName := 'valor_outras_despesas';
    Itens_EntradaDatasetvalor_outras_despesas.Required := False;
    Itens_EntradaDatasetvalor_preco_custo.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_preco_custo.Name := 'Itens_EntradaDatasetvalor_preco_custo';
    Itens_EntradaDatasetvalor_preco_custo.FieldName := 'valor_preco_custo';
    Itens_EntradaDatasetvalor_preco_custo.Required := False;
    Itens_EntradaDatasetvalor_preco_venda.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_preco_venda.Name := 'Itens_EntradaDatasetvalor_preco_venda';
    Itens_EntradaDatasetvalor_preco_venda.FieldName := 'valor_preco_venda';
    Itens_EntradaDatasetvalor_preco_venda.Required := False;
    Itens_EntradaDatasetvalor_icms_desonerado.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_desonerado.Name := 'Itens_EntradaDatasetvalor_icms_desonerado';
    Itens_EntradaDatasetvalor_icms_desonerado.FieldName := 'valor_icms_desonerado';
    Itens_EntradaDatasetvalor_icms_desonerado.Required := False;
    Itens_EntradaDatasetdesoneracao_icms_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdesoneracao_icms_id.Name := 'Itens_EntradaDatasetdesoneracao_icms_id';
    Itens_EntradaDatasetdesoneracao_icms_id.FieldName := 'desoneracao_icms_id';
    Itens_EntradaDatasetdesoneracao_icms_id.Required := False;
    Itens_EntradaDatasetvalor_icms_proprio_st.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_proprio_st.Name := 'Itens_EntradaDatasetvalor_icms_proprio_st';
    Itens_EntradaDatasetvalor_icms_proprio_st.FieldName := 'valor_icms_proprio_st';
    Itens_EntradaDatasetvalor_icms_proprio_st.Required := False;
    Itens_EntradaDatasetvalor_icms_original.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_original.Name := 'Itens_EntradaDatasetvalor_icms_original';
    Itens_EntradaDatasetvalor_icms_original.FieldName := 'valor_icms_original';
    Itens_EntradaDatasetvalor_icms_original.Required := False;
    Itens_EntradaDatasetplano_contas_contabil_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetplano_contas_contabil_id.Name := 'Itens_EntradaDatasetplano_contas_contabil_id';
    Itens_EntradaDatasetplano_contas_contabil_id.FieldName := 'plano_contas_contabil_id';
    Itens_EntradaDatasetplano_contas_contabil_id.Required := False;
    Itens_EntradaDatasetcodigo_interno.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_interno.Name := 'Itens_EntradaDatasetcodigo_interno';
    Itens_EntradaDatasetcodigo_interno.FieldName := 'codigo_interno';
    Itens_EntradaDatasetcodigo_interno.Required := True;
    Itens_EntradaDatasetexcluido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetexcluido.Name := 'Itens_EntradaDatasetexcluido';
    Itens_EntradaDatasetexcluido.FieldName := 'excluido';
    Itens_EntradaDatasetexcluido.Required := False;
    Itens_EntradaDatasetinclusao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetinclusao.Name := 'Itens_EntradaDatasetinclusao';
    Itens_EntradaDatasetinclusao.FieldName := 'inclusao';
    Itens_EntradaDatasetinclusao.Required := False;
    Itens_EntradaDatasetalteracao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetalteracao.Name := 'Itens_EntradaDatasetalteracao';
    Itens_EntradaDatasetalteracao.FieldName := 'alteracao';
    Itens_EntradaDatasetalteracao.Required := False;
    Itens_EntradaDatasetexclusao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetexclusao.Name := 'Itens_EntradaDatasetexclusao';
    Itens_EntradaDatasetexclusao.FieldName := 'exclusao';
    Itens_EntradaDatasetexclusao.Required := False;
    XDataClientItens_EntradaGet.SetParentComponent(Self);
    XDataClientItens_EntradaGet.Name := 'XDataClientItens_EntradaGet';
    XDataClientItens_EntradaGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientItens_EntradaGet, Self, 'OnLoad', 'XDataClientItens_EntradaGetLoad');
    XDataClientItens_EntradaGet.Left := 64;
    XDataClientItens_EntradaGet.Top := 8;
    XDataClientItens_EntradaDelete.SetParentComponent(Self);
    XDataClientItens_EntradaDelete.Name := 'XDataClientItens_EntradaDelete';
    XDataClientItens_EntradaDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientItens_EntradaDelete, Self, 'OnLoad', 'XDataClientItens_EntradaDeleteLoad');
    SetEvent(XDataClientItens_EntradaDelete, Self, 'OnError', 'XDataClientItens_EntradaDeleteError');
    XDataClientItens_EntradaDelete.Left := 64;
    XDataClientItens_EntradaDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcompra_id.AfterLoadDFMValues;
    edcompra_id.AfterLoadDFMValues;
    lbitem.AfterLoadDFMValues;
    editem.AfterLoadDFMValues;
    lbproduto_id.AfterLoadDFMValues;
    edproduto_id.AfterLoadDFMValues;
    lbgrade_produto_id.AfterLoadDFMValues;
    edgrade_produto_id.AfterLoadDFMValues;
    lbproduto_nome.AfterLoadDFMValues;
    edproduto_nome.AfterLoadDFMValues;
    lbmovimenta_estoque.AfterLoadDFMValues;
    edmovimenta_estoque.AfterLoadDFMValues;
    lbestoque_inicial.AfterLoadDFMValues;
    edestoque_inicial.AfterLoadDFMValues;
    lbestoque_final.AfterLoadDFMValues;
    edestoque_final.AfterLoadDFMValues;
    lbcfop_cfop.AfterLoadDFMValues;
    edcfop_cfop.AfterLoadDFMValues;
    lbunidade_id.AfterLoadDFMValues;
    edunidade_id.AfterLoadDFMValues;
    lbquantidade.AfterLoadDFMValues;
    edquantidade.AfterLoadDFMValues;
    lbvalor_unitario.AfterLoadDFMValues;
    edvalor_unitario.AfterLoadDFMValues;
    lbdesconto.AfterLoadDFMValues;
    eddesconto.AfterLoadDFMValues;
    lbvalor_desconto.AfterLoadDFMValues;
    edvalor_desconto.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    lbvalor_base_icms.AfterLoadDFMValues;
    edvalor_base_icms.AfterLoadDFMValues;
    lbicms.AfterLoadDFMValues;
    edicms.AfterLoadDFMValues;
    lbvalor_icms.AfterLoadDFMValues;
    edvalor_icms.AfterLoadDFMValues;
    lbicms_dif.AfterLoadDFMValues;
    edicms_dif.AfterLoadDFMValues;
    lbvalor_icms_dif.AfterLoadDFMValues;
    edvalor_icms_dif.AfterLoadDFMValues;
    lbvalor_base_st.AfterLoadDFMValues;
    edvalor_base_st.AfterLoadDFMValues;
    lbst.AfterLoadDFMValues;
    edst.AfterLoadDFMValues;
    lbvalor_st.AfterLoadDFMValues;
    edvalor_st.AfterLoadDFMValues;
    lbicms_red.AfterLoadDFMValues;
    edicms_red.AfterLoadDFMValues;
    lbvalor_icms_red.AfterLoadDFMValues;
    edvalor_icms_red.AfterLoadDFMValues;
    lbvalor_base_ipi.AfterLoadDFMValues;
    edvalor_base_ipi.AfterLoadDFMValues;
    lbipi.AfterLoadDFMValues;
    edipi.AfterLoadDFMValues;
    lbvalor_ipi.AfterLoadDFMValues;
    edvalor_ipi.AfterLoadDFMValues;
    lbvalor_custo_unitario.AfterLoadDFMValues;
    edvalor_custo_unitario.AfterLoadDFMValues;
    lblote_fabricacao.AfterLoadDFMValues;
    edlote_fabricacao.AfterLoadDFMValues;
    lbdata_fabricacao.AfterLoadDFMValues;
    eddata_fabricacao.AfterLoadDFMValues;
    lbvalidade.AfterLoadDFMValues;
    edvalidade.AfterLoadDFMValues;
    lbdias_validade.AfterLoadDFMValues;
    eddias_validade.AfterLoadDFMValues;
    lbvalor_frete.AfterLoadDFMValues;
    edvalor_frete.AfterLoadDFMValues;
    lbvalor_despensa_acessoria.AfterLoadDFMValues;
    edvalor_despensa_acessoria.AfterLoadDFMValues;
    lbvalor_seguro.AfterLoadDFMValues;
    edvalor_seguro.AfterLoadDFMValues;
    lbvalor_outras.AfterLoadDFMValues;
    edvalor_outras.AfterLoadDFMValues;
    lbcst_id.AfterLoadDFMValues;
    edcst_id.AfterLoadDFMValues;
    lbcst_ipi_id.AfterLoadDFMValues;
    edcst_ipi_id.AfterLoadDFMValues;
    lbcst_pis_id.AfterLoadDFMValues;
    edcst_pis_id.AfterLoadDFMValues;
    lbcst_cofins_id.AfterLoadDFMValues;
    edcst_cofins_id.AfterLoadDFMValues;
    lbcsosn_id.AfterLoadDFMValues;
    edcsosn_id.AfterLoadDFMValues;
    lborigem_csosn_id.AfterLoadDFMValues;
    edorigem_csosn_id.AfterLoadDFMValues;
    lbquantidade_selo_ipi.AfterLoadDFMValues;
    edquantidade_selo_ipi.AfterLoadDFMValues;
    lbvalor_base_issqn.AfterLoadDFMValues;
    edvalor_base_issqn.AfterLoadDFMValues;
    lbissqn.AfterLoadDFMValues;
    edissqn.AfterLoadDFMValues;
    lbcodigo_issqn.AfterLoadDFMValues;
    edcodigo_issqn.AfterLoadDFMValues;
    lbvalor_issqn.AfterLoadDFMValues;
    edvalor_issqn.AfterLoadDFMValues;
    lbvalor_base_pis.AfterLoadDFMValues;
    edvalor_base_pis.AfterLoadDFMValues;
    lbpis.AfterLoadDFMValues;
    edpis.AfterLoadDFMValues;
    lbvalor_pis.AfterLoadDFMValues;
    edvalor_pis.AfterLoadDFMValues;
    lbvalor_base_cofins.AfterLoadDFMValues;
    edvalor_base_cofins.AfterLoadDFMValues;
    lbcofins.AfterLoadDFMValues;
    edcofins.AfterLoadDFMValues;
    lbvalor_cofins.AfterLoadDFMValues;
    edvalor_cofins.AfterLoadDFMValues;
    lbcodigo_bc_piscofins_id.AfterLoadDFMValues;
    edcodigo_bc_piscofins_id.AfterLoadDFMValues;
    lbcodigo_credito_piscofins_id.AfterLoadDFMValues;
    edcodigo_credito_piscofins_id.AfterLoadDFMValues;
    lbvalor_base_st_retida.AfterLoadDFMValues;
    edvalor_base_st_retida.AfterLoadDFMValues;
    lbst_retida.AfterLoadDFMValues;
    edst_retida.AfterLoadDFMValues;
    lbvalor_st_retida.AfterLoadDFMValues;
    edvalor_st_retida.AfterLoadDFMValues;
    lbvalor_pis_retido.AfterLoadDFMValues;
    edvalor_pis_retido.AfterLoadDFMValues;
    lbvalor_cofins_retido.AfterLoadDFMValues;
    edvalor_cofins_retido.AfterLoadDFMValues;
    lbvalor_desconto_nota.AfterLoadDFMValues;
    edvalor_desconto_nota.AfterLoadDFMValues;
    lbvalor_total_liquido.AfterLoadDFMValues;
    edvalor_total_liquido.AfterLoadDFMValues;
    lbvalor_total_impostos.AfterLoadDFMValues;
    edvalor_total_impostos.AfterLoadDFMValues;
    lbvalor_frete_por_fora.AfterLoadDFMValues;
    edvalor_frete_por_fora.AfterLoadDFMValues;
    lbvalor_outras_despesas.AfterLoadDFMValues;
    edvalor_outras_despesas.AfterLoadDFMValues;
    lbvalor_preco_custo.AfterLoadDFMValues;
    edvalor_preco_custo.AfterLoadDFMValues;
    lbvalor_preco_venda.AfterLoadDFMValues;
    edvalor_preco_venda.AfterLoadDFMValues;
    lbvalor_icms_desonerado.AfterLoadDFMValues;
    edvalor_icms_desonerado.AfterLoadDFMValues;
    lbdesoneracao_icms_id.AfterLoadDFMValues;
    eddesoneracao_icms_id.AfterLoadDFMValues;
    lbvalor_icms_proprio_st.AfterLoadDFMValues;
    edvalor_icms_proprio_st.AfterLoadDFMValues;
    lbvalor_icms_original.AfterLoadDFMValues;
    edvalor_icms_original.AfterLoadDFMValues;
    lbplano_contas_contabil_id.AfterLoadDFMValues;
    edplano_contas_contabil_id.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Itens_EntradaDataset.AfterLoadDFMValues;
    Itens_EntradaDatasetid.AfterLoadDFMValues;
    Itens_EntradaDatasetaliado_id.AfterLoadDFMValues;
    Itens_EntradaDatasetdata_base_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcompra_id.AfterLoadDFMValues;
    Itens_EntradaDatasetitem.AfterLoadDFMValues;
    Itens_EntradaDatasetproduto_id.AfterLoadDFMValues;
    Itens_EntradaDatasetgrade_produto_id.AfterLoadDFMValues;
    Itens_EntradaDatasetproduto_nome.AfterLoadDFMValues;
    Itens_EntradaDatasetmovimenta_estoque.AfterLoadDFMValues;
    Itens_EntradaDatasetestoque_inicial.AfterLoadDFMValues;
    Itens_EntradaDatasetestoque_final.AfterLoadDFMValues;
    Itens_EntradaDatasetcfop_cfop.AfterLoadDFMValues;
    Itens_EntradaDatasetunidade_id.AfterLoadDFMValues;
    Itens_EntradaDatasetquantidade.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_unitario.AfterLoadDFMValues;
    Itens_EntradaDatasetdesconto.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_desconto.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_total.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_icms.AfterLoadDFMValues;
    Itens_EntradaDataseticms.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms.AfterLoadDFMValues;
    Itens_EntradaDataseticms_dif.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_dif.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_st.AfterLoadDFMValues;
    Itens_EntradaDatasetst.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_st.AfterLoadDFMValues;
    Itens_EntradaDataseticms_red.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_red.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_ipi.AfterLoadDFMValues;
    Itens_EntradaDatasetipi.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_ipi.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_custo_unitario.AfterLoadDFMValues;
    Itens_EntradaDatasetlote_fabricacao.AfterLoadDFMValues;
    Itens_EntradaDatasetdata_fabricacao.AfterLoadDFMValues;
    Itens_EntradaDatasetvalidade.AfterLoadDFMValues;
    Itens_EntradaDatasetdias_validade.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_frete.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_despensa_acessoria.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_seguro.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_outras.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_ipi_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_pis_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_cofins_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcsosn_id.AfterLoadDFMValues;
    Itens_EntradaDatasetorigem_csosn_id.AfterLoadDFMValues;
    Itens_EntradaDatasetquantidade_selo_ipi.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_issqn.AfterLoadDFMValues;
    Itens_EntradaDatasetissqn.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_issqn.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_issqn.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_pis.AfterLoadDFMValues;
    Itens_EntradaDatasetpis.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_pis.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_cofins.AfterLoadDFMValues;
    Itens_EntradaDatasetcofins.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_cofins.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_bc_piscofins_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_credito_piscofins_id.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_st_retida.AfterLoadDFMValues;
    Itens_EntradaDatasetst_retida.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_st_retida.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_pis_retido.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_cofins_retido.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_desconto_nota.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_total_liquido.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_total_impostos.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_frete_por_fora.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_outras_despesas.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_preco_custo.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_preco_venda.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_desonerado.AfterLoadDFMValues;
    Itens_EntradaDatasetdesoneracao_icms_id.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_proprio_st.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_original.AfterLoadDFMValues;
    Itens_EntradaDatasetplano_contas_contabil_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_interno.AfterLoadDFMValues;
    Itens_EntradaDatasetexcluido.AfterLoadDFMValues;
    Itens_EntradaDatasetinclusao.AfterLoadDFMValues;
    Itens_EntradaDatasetalteracao.AfterLoadDFMValues;
    Itens_EntradaDatasetexclusao.AfterLoadDFMValues;
    XDataClientItens_EntradaGet.AfterLoadDFMValues;
    XDataClientItens_EntradaDelete.AfterLoadDFMValues;
  end;
end;

end.
